import {
  AUTH_URL,
  ADMIN_URL,
  PROJECT_URL,
  MEMBER_URL,
  REPORT_URL,
  OKR_URL,
  REMINDER_URL,
  INVOICE_URL,
  TIMEOFF_URL,
  EXPENSE_URL,
  NUDGES_URL,
  SUPERADMIN_URL,
  HANDBOOK_URL,
  STRIPE_URL,
  CULTURALFIT,
  HELPDESK_URL,
  TODOS_URL,
  STRIPE_URL_ONE,
  STRATEGY_BUILDER,
  SUPERADMIN_PRICING_URL,
  AI_CHAT_URL,
  AI_SOW_CHAT_URL,
} from "../constants/API_constants";
import axios from "axios";
import { axiosInstance } from "./interceptor";

const STRATEGY_API_KEY = process.env.REACT_APP_STRATEGY_API_KEY;

export const loginService = (username, password) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "login",
      parameters: {
        userName: username,
        password: password,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const superAdminloginService = (username, password) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "superAdminLogin",
      parameters: {
        userName: username,
        password: password,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getSSOLoginUrlService = (redirectUri) => {
  return axiosInstance
    .get(AUTH_URL + "/sso/login", {
      params: {
        redirectUri: redirectUri,
      },
    })
    .then((res) => res.data);
};
export const ssoLogoutService = (redirectUri) => {
  return axiosInstance
    .get(AUTH_URL + "/sso/logout", {
      params: { redirectUri },
    })
    .then((res) => res.data);
};

export const ssoCallbackService = (
  authorizationCode,
  redirectUri,
  workspaceId,
  priceLookupKey,
  inviteToken,
  inviteType,
  codeVerifier,
) => {
  return axiosInstance
    .post(AUTH_URL + "/sso/callback", {
      flag: "ssoCallback",
      parameters: {
        workspaceId: workspaceId || "",
        priceLookupKey: priceLookupKey || "",
        inviteToken: inviteToken || "",
        inviteType: inviteType || "",
        ssoRequest: {
          authorizationCode: authorizationCode,
          codeVerifier: codeVerifier,
          redirectUri: redirectUri,
        },
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const ssoRefreshTokenService = (memberId) => {
  // Use plain axios (NOT axiosInstance) to avoid the 401 interceptor
  // triggering another refresh and causing an infinite loop.
  // URL must match /auth/sso/refresh (same as interceptor.js).
  return axios
    .post(AUTH_URL + "/auth/sso/refresh", {
      flag: "ssoRefresh",
      parameters: {
        ssoRequest: {
          authorizationCode: memberId, // UUID (id_member), never a JWT
        },
      },
    })
    .then((response) => {
      return response.data;
    });
};
export const signupService = (payload) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "signup",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const validateSignupService = (id) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "validateSignup",
      parameters: {
        memberId: id,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const refreshTokenService = (token) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "refreshtoken",
      parameters: {
        refresh_token: token,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const changePasswordService = (payload) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/changepassword", {
      flag: "changePassword",
      parameters: payload,
    })
    .then((response) => response.data);
};

export const forgotActionPasswordService = (
  reset_id,
  newPassword,
  confirmPassword,
) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "resetPasswordAction",
      parameters: {
        memberId: reset_id,
        password: newPassword,
        confirm: confirmPassword,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const validateInviteService = (invite_token) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "validateInvite",
      parameters: {
        inviteToken: invite_token,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const forgotPasswordService = (userName) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "forgot",
      parameters: {
        userName: userName,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getWorkspaceDetailsService = (workspaceId, geoLocationStatus) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/workspace?workspaceId=${workspaceId}&geoLocationStatus=${geoLocationStatus}&flag=getWorkspace`,
    )
    .then((response) => {
      return response.data;
    });
};

export const createWorkspaceService = (workspaceName) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace", {
      flag: "createWorkspace",
      parameters: {
        workspaceName: workspaceName,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const mondayApiService = (mondayPayload) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/manage/platform-keys", {
      flag: "MANAGE_WORKSPACE_PLATFORM",
      parameters: mondayPayload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getAllplatformService = (workspaceId, platform) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/workspace/manage/platform-keys?flag=GET_WORKSPACE_PLATFORM_DETAILS&workspaceId=${workspaceId}&platform=${platform}`,
    )
    .then((resp) => {
      return resp.data;
    });
};

export const searchWorkspaceService = (Status, page, posts, value) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/search", {
      flag: "searchWorkspace",
      parameters: {
        name: value,
        page: page,
        limit: posts,
        orderby: "name",
        sortby: Status,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const manageWorkspaceService = (workspaceId, isChecked) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/manage", {
      flag: "manageWorkspace",
      parameters: {
        workspaceId: workspaceId,
        status: "false",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateWorkspaceService = (payload) => {
  return axiosInstance
    .patch(ADMIN_URL + "/workspace/setfield", {
      flag: "updateWorkspace",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

//Workspace edit api
export const editAndUpdateWorspaceService = (id, name) => {
  return axiosInstance
    .patch(`${ADMIN_URL}/workspace?flag=updateName&id=${id}&name=${name}`)
    .then((res) => {
      return res.data;
    });
};

export const searchCustomerService = (
  workspaceID,
  page,
  posts,
  value,
  Status,
  customStatus,
  orderBy,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/customer/search", {
      flag: "searchCustomer",
      parameters: {
        workspaceId: workspaceID,
        search: value,
        page: page,
        limit: posts,
        orderby: orderBy,
        sortby: Status,
        status: customStatus,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addCustomerService = (
  workspaceId,
  customerName,
  email,
  phone,
  countryCode,
  fromAddress,
  customerPrefixCode,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/customer", {
      flag: "addCustomer",
      parameters: {
        workspaceId: workspaceId,
        name: customerName,
        email: email,
        countryCode: countryCode,
        phone: phone,
        address: fromAddress,
        customerPrefixCode: customerPrefixCode,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateCustomerService = (
  customer_id,
  workspase_id,
  name,
  email,
  phone,
  countryCode,
  address,
  customerPrefixCode,
) => {
  return axiosInstance
    .patch(ADMIN_URL + "/customer", {
      flag: "editCustomer",
      parameters: {
        customerId: customer_id,
        workspaceId: workspase_id,
        name: name,
        email: email,
        countryCode: countryCode,
        phone: phone,
        address: address,
        customerPrefixCode: customerPrefixCode,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const createDepartmentService = (
  workspaceId,
  name,
  DepartmentHead,
  description,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/department", {
      flag: "createDepartment",
      parameters: {
        workspaceId: workspaceId,
        name: name,
        departmentHead: DepartmentHead,
        description: description,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getDepartmentDetailsService = (workspaceId, departmentId) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/department?deptValue=${""}&workspaceId=${workspaceId}&flag=getDepartment&getBy=name`,
    )
    .then((response) => {
      return response.data;
    });
};

export const searchDepartmentService = (
  workspaceID,
  page,
  posts,
  Status,
  value,
  departmentStatus,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/department/search", {
      flag: "searchDepartment",
      parameters: {
        workspaceId: workspaceID,
        name: value,
        page: page,
        limit: posts,
        orderby: "name",
        sortby: Status,
        status: departmentStatus,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const GetDepartmentHead = (payload) => {
  return axiosInstance
    .post(ADMIN_URL + "/department/getdepthead", {
      flag: "departmentHeadDropDown",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const updateDepartmentService = (
  workspaceId,
  departmentId,
  name,
  departmentHead,
  description,
) => {
  return axiosInstance
    .patch(ADMIN_URL + "/department/setfield", {
      flag: "setDepartmentValue",
      parameters: {
        workspaceId: workspaceId,
        departmentId: departmentId,
        departmentName: name,
        description: description,
        departmentHead: departmentHead,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteDepartmentService = (
  workspaceId,
  department_id,
  isDisableProject,
  status,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/department/delete", {
      flag: "deleteDepartment",
      parameters: {
        workspaceId: workspaceId,
        departmentId: department_id,
        isDisableProject: isDisableProject,
        status: status,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getMembersDropdownService = (workspaceId) => {
  return axiosInstance
    .get(
      `${REPORT_URL}/getMembersDropdown?flag=getMembersListDropdown&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const createProjectService = (
  workspaceID,
  customerId,
  departmentId,
  projectName,
  visibility,
  billable,
  color,
  dynamicFields,
  templatename,
  createtemplate,
  managerId,
  projectType,
  currency,
  budgetAmount,
  sowDetails,
  module,
  internalBudgetAmount,
  toolsInfraBudgetAmount,
  clientManDays,
  internalEstimateManDays,
  effectiveDate,
  projectCodePrefix,
  projectEndDate,
  phases,
  idFinancier,
  psManagerIds,
  soNumber,
  revenueType,
  accountManagerId,
  productOffered,
  syncWithAmlyDevops,
  projectMembers,
) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project", {
      flag: "createProject",
      parameters: {
        workspaceId: workspaceID,
        departmentId: departmentId,
        customerId: customerId,
        name: projectName,
        visibility: visibility,
        colourCode: color,
        isBillable: billable,
        notes: "",
        createtemplate: createtemplate,
        templatename: templatename,
        dynamicfields: dynamicFields,
        managerId: managerId,
        projectType: projectType,
        currency: currency,
        budgetAmount: budgetAmount,
        internalBudgetAmount: internalBudgetAmount,
        toolsInfraBudgetAmount: toolsInfraBudgetAmount,
        clientManDays: clientManDays,
        internalEstimateManDays: internalEstimateManDays,
        effectiveDate: effectiveDate || null,
        projectEndDate: projectEndDate || null,
        sowDetails: sowDetails,
        module: module,
        projectCodePrefix: projectCodePrefix,
        phases: phases,
        idFinancier: idFinancier,
        psManagerIds: psManagerIds,
        soNumber: soNumber || null,
        revenueType: revenueType || null,
        accountManagerId: accountManagerId || null,
        productOffered: productOffered || "",
        syncWithAmlyDevops: syncWithAmlyDevops !== undefined ? Boolean(syncWithAmlyDevops) : false,
        projectMembers: projectMembers || [],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateProjectPhasesService = ({ projectId, workspaceId, phases }) => {
  // API expects flag as query param and parameters in body
  return axiosInstance
    .patch(PROJECT_URL + "/admin/project/phases?flag=updateProjectPhases", {
      parameters: {
        projectId,
        workspaceId,
        phases,
      },
    })
    .then((response) => response.data);
};

// Writes only phase_order; phaseIds are the saved phases top to bottom
export const reorderProjectPhasesService = ({ projectId, workspaceId, phaseIds }) => {
  return axiosInstance
    .patch(PROJECT_URL + "/admin/project/phases/order?flag=reorderProjectPhases", {
      parameters: {
        projectId,
        workspaceId,
        phaseIds,
      },
    })
    .then((response) => response.data);
};

export const createProjectPhaseService = (payload) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/phase?flag=createProjectPhase", {
      parameters: payload,
    })
    .then((response) => response.data);
};

export const updateProjectPhaseService = (payload) => {
  return axiosInstance
    .patch(PROJECT_URL + "/admin/project/phase?flag=updateProjectPhase", {
      parameters: payload, // must include phaseId
    })
    .then((response) => response.data);
};

export const getProjectMembersBasicService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/members/basic?flag=GET_PROJECT_MEMBERS_BASIC&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getProjectPhasePlanService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/phase-progress?flag=GET_PROJECT_PHASE_PROGRESS&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getProjectTMPhasePlanService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/phase-progress?flag=GET_PROJECT_TM_PHASE_PROGRESS&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getInternalProjectPlanService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/phase-progress?flag=GET_INTERNAL_PROJECT_PLAN_STATUS&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getProjectINTPhasePlanService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/phase-progress?flag=GET_PROJECT_INT_PHASE_PROGRESS&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getPhaseTagsService = (phaseId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/phase/tags?flag=getPhaseTags&phaseId=${phaseId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const createPhaseTagService = ({ phaseId, projectId, workspaceId, tagName }) => {
  return axiosInstance
    .post(`${PROJECT_URL}/admin/project/phase/tag?flag=createPhaseTag`, {
      parameters: {
        phaseId,
        projectId,
        workspaceId,
        tagName,
      },
    })
    .then((response) => response.data);
};

export const deletePhaseTagService = (tagId, phaseId, projectId, workspaceId) => {
  return axiosInstance
    .delete(
      `${PROJECT_URL}/admin/project/phase/tag?flag=deletePhaseTag&tagId=${tagId}&phaseId=${phaseId}&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};



export const getProjectHistoryService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/history?projectId=${projectId}&workspaceId=${workspaceId}&flag=getProjectHistory`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateProjectBudgetService = ({
  projectId,
  workspaceId,
  clientBudget,
  internalBudget,
  clientManDays,
  internalManDays,
  currency,
  reason,
  changeRef,
  effectiveDate,
}) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/budget", {
      flag: "updateProjectBudget",
      parameters: {
        projectId,
        workspaceId,
        clientBudget,
        internalBudget,
        clientManDays,
        internalManDays,
        currency,
        reason,
        changeRef,
        effectiveDate,
      },
    })
    .then((response) => response.data);
};

export const getProjectBudgetService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/budget?projectId=${projectId}&workspaceId=${workspaceId}&flag=getProjectBudget`,
    )
    .then((response) => response.data);
};

export const updateMemberSalaryService = ({
  memberId,
  projectId,
  workspaceId,
  baseSalary,
  currency,
  effectiveDate,
  reason,
}) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/salary", {
      flag: "updateMemberSalary",
      parameters: {
        memberId,
        projectId,
        workspaceId,
        baseSalary,
        currency,
        effectiveDate,
        reason,
      },
    })
    .then((response) => response.data);
};

export const getMemberSalaryService = ({
  memberId,
  projectId,
  workspaceId,
}) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/salary?memberId=${memberId}&projectId=${projectId}&workspaceId=${workspaceId}&flag=getMemberSalary`,
    )
    .then((response) => response.data);
};

export const getProjectPayrollSummaryService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/payroll-summary?projectId=${projectId}&workspaceId=${workspaceId}&flag=getProjectPayrollSummary`,
    )
    .then((response) => response.data);
};

/*==========Submit for approval code start here==========*/
export const submitForApprovalTimesheetService = (FromandToDate) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/submitForApproval", {
      flag: "submitForApproval",
      parameters: {
        fromDate: FromandToDate?.FromandToDate?.fromDate,
        toDate: FromandToDate?.FromandToDate?.toDate,
        workspaceId: FromandToDate?.FromandToDate?.workspaceId,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Submit for approval code end here==========*/

export const searchProjectService = (
  workspaceId,
  value,
  page,
  posts,
  orderBy,
  sortBy,
  filterOption,
  departmentIds,
  customerIds,
  visibility,
  offset
) => {
  const pageNumber = Number(page) || 1;
  const limit = Number(posts) || 10;
  const parameters = {
    workspaceId: workspaceId,
    search: value,
    page: pageNumber,
    limit: limit,
    // Infinite-scroll callers pass the API's nextOffset; page callers get the offset of their page
    offset: offset ?? (pageNumber - 1) * limit,
    orderby: orderBy,
    sortby: sortBy,
    status: filterOption,
  };

  if (departmentIds) parameters.departmentIds = departmentIds;
  if (customerIds) parameters.customerIds = customerIds;
  if (visibility) parameters.visibility = visibility;

  return axiosInstance
    .post(PROJECT_URL + "/admin/project/search", {
      flag: "projectSearch",
      parameters: parameters,
    })
    .then((response) => {
      return response.data;
    });
};

export const createTeamService = (workspaceId, groupName) => {
  return axiosInstance
    .post(ADMIN_URL + "/team", {
      flag: "createMemberGroup",
      parameters: {
        workspaceId: workspaceId,
        groupName: groupName,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const searchTeamService = (
  workspaceId,
  value,
  page,
  posts,
  Status,
  groupStatus,
  orderBy,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/team/search", {
      flag: "searchMemberGroup",
      parameters: {
        workspaceId: workspaceId,
        name: value,
        page: page,
        limit: posts,
        orderby: orderBy,
        sortby: Status,
        status: groupStatus,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const createTaskService = (
  workspaceID,
  idDepartments,
  idProject,
  name,
  memberId,
  module,
  phaseId,
  phaseTagId,
) => {
  return axiosInstance
    .post(PROJECT_URL + "/project/task/create", {
      flag: "projectTaskCreate",
      parameters: {
        projectId: idProject,
        name: name,
        workspaceId: workspaceID,
        departmentId: idDepartments,
        groupIds: [
          {
            groupId: "1",
          },
        ],
        memberIds: [
          {
            memberId: memberId,
          },
        ],
        module: module,
        // Sent only for fixed-price projects, where a new task must carry a phase tag
        ...(phaseId ? { phaseId } : {}),
        ...(phaseTagId ? { phaseTagId } : {}),
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const searchTaskService = (
  workspaceID,
  idDepartments,
  idProject,
  page,
  posts,
  taskStatus,
  value,
  sortBy,
) => {
  return axiosInstance
    .post(PROJECT_URL + "/project/task/search", {
      flag: "projectTaskSearch",
      parameters: {
        projectId: idProject,
        workspaceId: workspaceID,
        departmentId: idDepartments,
        search: value,
        status: taskStatus,
        page: page,
        limit: posts,
        orderby: "name",
        sortby: sortBy,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addMemberService = (workspaceId, email) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/add", {
      flag: "addMember",
      parameters: {
        workspaceId: workspaceId,
        emails: email,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addMemberByLinkService = (workspaceId) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/addbylink", {
      flag: "addMemberByLink",
      parameters: {
        workspaceId: workspaceId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getMemberSalaryLogsService = (workspaceId, memberId) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/salary/logs", {
      flag: "getMemberSalaryLogs",
      parameters: {
        workspaceId: workspaceId,
        memberId: memberId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getMemberSalaryTimelineService = (workspaceId, memberId) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/salary/timeline", {
      parameters: {
        workspaceId: workspaceId,
        memberId: memberId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const searchMemberService = (
  workspaceId,
  page,
  posts,
  memberStatus,
  Status,
  value,
  workspaceRoleId,
  groupIds,
  reportingManagerId,
  offset,
) => {
  const pageNumber = Number(page) || 1;
  const limit = Number(posts) || 10;
  return axiosInstance
    .post(MEMBER_URL + "/member/search", {
      flag: "searchMember",
      parameters: {
        workspaceId: workspaceId,
        name: value,
        page: pageNumber,
        limit: limit,
        // Infinite-scroll callers pass the API's nextOffset; page callers get the offset of their page
        offset: offset ?? (pageNumber - 1) * limit,
        orderby: "name",
        sortby: Status,
        status: memberStatus,
        workspaceRoleId: workspaceRoleId || "",
        groupIds: groupIds || [],
        reportingManagerId: reportingManagerId || "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const exportMembersService = (parameters) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/export?flag=exportMembers", {
      flag: "exportMembers",
      parameters: parameters,
    })
    .then((response) => {
      return response.data;
    });
};

export const projectStatusService = (status, projectId, workspaceID) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/admin/project?flag=projectEnableDisable&projectId=${projectId}&status=${status}&workspaceId=${workspaceID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateProjectStatusService = (projectId, status, workspaceID) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/admin/project/status-update?flag=updateProjectStatus&projectId=${projectId}&status=${status}&workspaceId=${workspaceID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const projectTaskStatusService = (id, workspaceId, status) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/project/task/status?projectTaskId=${id}&status=${status}&workspaceId=${workspaceId}&flag=SetProjectStatus`,
    )
    .then((response) => {
      return response.data;
    });
};

export const projectMemberListService = (idWorkspace, idProject) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/access/memberlist", {
      flag: "projectAccessSearch",
      parameters: {
        projectId: idProject,
        workspaceId: idWorkspace,
        orderBy: "bill",
        sortBy: "asc",
        limit: "50",
        page: "1",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const memberProjectsService = (workspaceID, id_member) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/all/projects?flag=getAllActiveMemberProjects&memberId=${id_member}&workspaceId=${workspaceID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const memberAccessService = (memberId, workspaceId, enabled) => {
  return axiosInstance
    .patch(
      `${MEMBER_URL}/member/access?flag=setMemberAccess&memberId=${memberId}&workspaceId=${workspaceId}&enabled=${enabled}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const memberGroupsService = (idWorkspace) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/groups?flag=getGroupsList&workspaceId=${idWorkspace}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getProjectDetailsService = (idProject, idWorkspace) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/setting?projectId=${idProject}&workspaceId=${idWorkspace}&flag=getProjectBillingStatus`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getWorkSpaceMemberService = (
  idWorkspace,
  idProject,
  value,
  page,
  posts,
  memberStatus,
  groupStatus,
  postss,
  pages,
  memberTabStatus,
  groupTabStatus,
) => {
  return axiosInstance
    .post(PROJECT_URL + "/project/workspace/access", {
      flag: "getProjectWorkSpaceMembers",
      parameters: {
        workspaceId: idWorkspace,
        projectId: idProject,
        search: value,
        groupOrderBy: "name",
        groupSortBy: groupStatus,
        memberOrderBy: "name",
        memberSortBy: memberStatus,
        groupLimit: postss,
        groupPage: pages,
        memberLimit: posts,
        memberPage: page,
        memberStatus: memberTabStatus,
        groupStatus: groupTabStatus,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editProjectMemberMdDaysService = (idWorkspace, id, mdDays) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/admin/project/edit/mddays?flag=editProjectMemberMdDays&id=${id}&workspaceId=${idWorkspace}&mdDays=${mdDays}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const removeMemberService = (idWorkspace, id, accessType, status) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/admin/project/access/member?flag=deleteProjectAccess&id=${id}&accessType=${accessType}&workspaceId=${idWorkspace}&status=${status}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getNonProjectMemberService = (idProject, value) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/addmember/list", {
      flag: "GetNonProjectGroupMember",
      parameters: {
        projectId: idProject,
        search: value,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateMemberService = (
  workspaceID,
  memberId,
  employeeId,
  firstName,
  lastName,
  countryCode,
  phone,
  email,
  dynamicfields,
  oldPassword,
  newPassword,
  confirmPassword,
  avatar,
  avatarFileName,
  avatardeleted,
  isContractor,
  billAmount,
  currency,
  salaryAmount,
  effectiveFrom,
  effectiveTill,
  remarks,
  includeMissingTimesheetAlerts,
  compensationType,
  pmSalary,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/edit", {
      flag: "editMember",
      parameters: {
        workspaceId: workspaceID,
        memberId: memberId,
        employeeId: employeeId,
        firstname: firstName,
        lastname: lastName,
        countryCode: countryCode,
        phone: phone,
        email: email,
        avatar: avatar,
        avatarFileName: avatarFileName,
        dynamicfields: dynamicfields,
        workingDays: "5",
        workingHours: "9",
        workStart: "9:50",
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
        avatardeleted: avatardeleted,
        isContractor: isContractor,
        billAmount: billAmount,
        currency: currency,
        ...(salaryAmount !== undefined &&
          salaryAmount !== "" && { salaryAmount }),
        ...(effectiveFrom !== undefined &&
          effectiveFrom !== "" && { effectiveFrom }),
        ...(effectiveTill !== undefined &&
          effectiveTill !== "" && { effectiveTill }),
        ...(remarks !== undefined && remarks !== "" && { remarks }),
        ...(includeMissingTimesheetAlerts !== undefined && {
          includeMissingTimesheetAlerts,
        }),
        ...(compensationType !== undefined &&
          compensationType !== "" && { compensationType }),
        pmSalary: Number(pmSalary) || 0,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateDefaultFlagService = (id) => {
  return axiosInstance
    .patch(
      `${ADMIN_URL}/workspace/update/default?workspaceId=${id}&flag=updateDefaultflag`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateMemberLanguageService = (
  memberId,
  workspaceId,
  languageCode,
) => {
  return axiosInstance
    .patch(
      `${MEMBER_URL}/member/language?memberId=${memberId}&workspaceId=${workspaceId}&languageCode=${languageCode}&flag=updateMemberLangCode`,
    )
    .then((response) => {
      return response?.data;
    });
};

export const updateMemberThemeService = (memberId, workspaceId, themeMode) => {
  return axiosInstance
    .patch(
      `${MEMBER_URL}/member/theme?memberId=${memberId}&workspaceId=${workspaceId}&theme=${themeMode}&flag=updateMemberWorkspaceTheme`,
    )
    .then((response) => {
      return response?.data;
    });
};

export const getWorkspaceListService = () => {
  return axiosInstance
    .get(`${MEMBER_URL}/member/workspaces?flag=getWorkspacesList`)
    .then((response) => {
      return response?.data;
    });
};

// One-time, permanent choice of "weekly" or "monthly" for a workspace's Allocation module -
// see Allocation.js / AllocationGranularitySetup.js. Locked server-side after the first call.
export const updateAllocationDefaultViewService = (workspaceId, allocationDefaultView) => {
  return axiosInstance
    .patch(ADMIN_URL + "/workspace/allocation-default-view", {
      flag: "updateAllocationDefaultView",
      parameters: { workspaceId, allocationDefaultView },
    })
    .then((response) => {
      return response?.data;
    });
};
export const getWorkspaceListRoleService = (workspaceId) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/workspaces/roles?flag=getWorkspaceRole&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response?.data;
    });
};

export const addMemberGroupService = (
  idProject,
  idWorkspace,
  groupsId,
  membersId,
) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/access/multi/addmember_group", {
      flag: "addMultiMemberGroup",
      parameters: {
        idProject: idProject,
        workspaceId: idWorkspace,
        idMember: [
          {
            idMember: membersId,
          },
        ],
        idGroup: [
          {
            idGroup: groupsId,
          },
        ],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const taskTrackService = (
  idProject,
  idWorkspace,
  page,
  posts,
  Status,
) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/status", {
      flag: "taskTrackTable",
      parameters: {
        idProject: idProject,
        workspaceId: idWorkspace,
        orderBy: "task",
        sortBy: Status,
        limit: posts,
        page: page,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateNotesService = (idProject, idWorkspace, content) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/notes", {
      flag: "updateNotes",
      parameters: {
        projectId: idProject,
        workspaceId: idWorkspace,
        notes: content,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getNotesService = (idProject, idWorkspace) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/notes?flag=getNotes&projectId=${idProject}&workspaceId=${idWorkspace}`,
    )
    .then((response) => {
      return response.data;
    });
};

// phaseId / projectTaskId limit the list to one phase's tags so tagging never moves a task
// to another phase; with neither, every tag of the project is returned.
export const getTaskTagPickerService = (projectId, workspaceId, phaseId = "", projectTaskId = "") => {
  return axiosInstance
    .post(PROJECT_URL + "/project/task/tag/picker", {
      flag: "getTaskTagPicker",
      parameters: {
        projectId,
        workspaceId,
        search: "",
        phaseId: phaseId || "",
        projectTaskId: projectTaskId || "",
      },
    })
    .then((response) => response.data);
};

export const updateTaskPhaseTagService = ({
  projectId,
  workspaceId,
  projectTaskId,
  phaseTagId,
  confirmRetag = true,
}) => {
  return axiosInstance
    .post(PROJECT_URL + "/project/task/tag/update", {
      flag: "updateTaskPhaseTag",
      parameters: {
        projectId,
        workspaceId,
        projectTaskId,
        phaseTagId,
        confirmRetag,
      },
    })
    .then((response) => response.data);
};

export const updateProjectTaskService = (
  idProject,
  idWorkspace,
  projectTaskId,
  taskName,
  addMembers,
  addGroups,
  phaseTagId,
  confirmRetag = true,
) => {
  const parameters = {
    projectId: idProject,
    workspaceId: idWorkspace,
    projectTaskId: projectTaskId,
    taskName: taskName || "",
    taskMembersIds: addMembers || [],
    taskGroupsIds: addGroups || [],
  };

  if (phaseTagId !== undefined) {
    parameters.phaseTagId = phaseTagId || "";
    parameters.confirmRetag = confirmRetag !== undefined ? confirmRetag : true;
  }

  return axiosInstance
    .post(PROJECT_URL + "/project/task/update", {
      flag: "updateProjectTask",
      parameters: parameters,
    })
    .then((response) => {
      return response.data;
    });
};

export const updateTeamService = (
  groupId,
  groupName,
  addMembers,
  removeMembers,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/team/update_team_info", {
      flag: "updateMemberGroupDetails",
      parameters: {
        groupId: groupId,
        groupName: groupName,
        addMembers: [
          {
            memberId: addMembers,
          },
        ],
        removeMembers: [
          {
            memberId: removeMembers,
          },
        ],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateGroupLatestService = (groupId, groupName, memberIds) => {
  return axiosInstance
    .post(ADMIN_URL + "/team/updateMemberInGroup", {
      flag: "updateMembersInGroup",
      parameters: {
        groupId: groupId,
        groupName: groupName,
        memberIds: memberIds,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateVisibilityService = (
  idProject,
  idWorkspace,
  visibilityData,
) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/admin/project/visibility?flag=updateVisibility&projectId=${idProject}&workspaceId=${idWorkspace}&visibility=${visibilityData}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getTaskAssigneeListService = (
  projectTaskId,
  idWorkspace,
  value,
) => {
  return axiosInstance
    .post(PROJECT_URL + "/project/task/assigneeslist", {
      flag: "getTaskAddAssigneeList",
      parameters: {
        projectTaskId: projectTaskId,
        workspaceId: idWorkspace,
        search: value,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getNonGroupService = (workspaceID, groupId) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/members/list", {
      flag: "getWorkspaceMembers",
      parameters: {
        idWorkspace: workspaceID,
        idGroup: groupId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteTeamService = (groupId, status) => {
  return axiosInstance
    .patch(
      `${ADMIN_URL}/team/deactivate?flag=deleteTeam&groupId=${groupId}&status=${status}`,
      {},
    )
    .then((response) => {
      return response.data;
    });
};

export const memberDropService = (workspaceId, memberId, value) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/groups/exists", {
      flag: "groupDropDown",
      parameters: {
        workspaceId: workspaceId,
        memberId: memberId,
        search: value,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateGroupService = (
  groupId,
  groupName,
  addMembers,
  removeMembers,
) => {
  return axiosInstance
    .post(ADMIN_URL + "/team/update_team_info", {
      flag: "updateMemberGroupDetails",
      parameters: {
        groupId: groupId,
        groupName: groupName,
        addMembers: [
          {
            memberId: addMembers,
          },
        ],
        removeMembers: [
          {
            memberId: removeMembers,
          },
        ],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const projectEstimateTypesService = (idProject, idWorkspace) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/estimatetypes?projectId=${idProject}&workspaceId=${idWorkspace}&flag=projectEstimateTypes`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateRoleService = (idMember, idWorkspace, roleId) => {
  return axiosInstance
    .patch(
      `${MEMBER_URL}/member/workspace/edit/role?flag=changeMemberRole&memberId=${idMember}&workspaceId=${idWorkspace}&roleId=${roleId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const reinviteMemberService = (workspaceId, emails) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/reinvite", {
      flag: "reinvitemember",
      parameters: {
        workspaceId: workspaceId,
        emails: emails,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateSettingsService = (
  projectId,
  workspaceId,
  name,
  departmentId,
  projectEstimateType,
  hours,
  billableDefaultFlag,
  estimateNonBillableTime,
  projectBillableRate,
  startdate,
  monthlyResetFlag,
  color,
  dynamicfields,
  managerId,
  accountManagerId,
  exportReportType,
  paymentDueDays,
  projectType,
  currency,
  budgetAmount,
  sowDetails,
  internalBudgetAmount,
  toolsInfraBudgetAmount,
  clientManDays,
  internalEstimateManDays,
  effectiveDate,
  projectCodePrefix,
  projectEndDate,
  idFinancier,
  psManagerIds,
  soNumber,
  revenueType,
  productOffered,
  syncWithAmlyDevops,
) => {
  return axiosInstance
    .patch(
      PROJECT_URL +
      "/admin/project/settings?flag=UpdateProjectSettings&isSettingsFlag=true",
      {
        flag: "UpdateProjectSettings",
        parameters: {
          projectId: projectId,
          workspaceId: workspaceId,
          name: name,
          departmentId: departmentId,
          projectEstimateType: projectEstimateType,
          hours: hours,
          color: color,
          billableDefaultFlag: billableDefaultFlag,
          estimateNonBillableTime: estimateNonBillableTime,
          projectBillableRate: projectBillableRate,
          startdate: startdate,
          enddate: "",
          monthlyResetFlag: monthlyResetFlag,
          dynamicfields: dynamicfields,
          managerId: managerId,
          accountManagerId: accountManagerId,
          exportReportType: exportReportType,
          paymentDueDays: JSON.parse(paymentDueDays),
          projectType: projectType,
          currency: currency,
          budgetAmount: budgetAmount,
          internalBudgetAmount: internalBudgetAmount,
          toolsInfraBudgetAmount: toolsInfraBudgetAmount,
          clientManDays: clientManDays,
          internalEstimateManDays: internalEstimateManDays,
          effectiveDate: effectiveDate,
          sowDetails: sowDetails,
          projectCodePrefix: projectCodePrefix,
          projectEndDate: projectEndDate,
          idFinancier: idFinancier,
          psManagerIds: psManagerIds,
          soNumber: soNumber || null,
          revenueType: revenueType || null,
          productOffered: productOffered || "",
          syncWithAmlyDevops: syncWithAmlyDevops !== undefined ? Boolean(syncWithAmlyDevops) : false,
        },
      },
    )
    .then((response) => {
      return response.data;
    });
};

export const updateBudgetManDaysService = (sendData) => {
  return axiosInstance
    .patch(
      "https://wf5fi699n0.execute-api.ap-south-1.amazonaws.com/dev/admin/project/budget-man-days",
      {
        parameters: sendData,
      },
      {
        params: { flag: "updateProjectBudgetAndManDays" },
      },
    )
    .then((response) => {
      return response.data;
    });
};

export const getBudgetAnalyticsService = (projectId, workspaceId) => {
  return axiosInstance
    .get(`${PROJECT_URL}/admin/project/budget-analytics`, {
      params: {
        projectId,
        workspaceId,
        flag: "GET_PROJECT_BUDGET_ANALYTICS",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getBudgetHistoryService = (projectId, workspaceId) => {
  return axiosInstance
    .get(`${PROJECT_URL}/admin/project/budget-history`, {
      params: {
        projectId,
        workspaceId,
        flag: "GET_PROJECT_BUDGET_HISTORY",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const timesheetProjectListService = (FromandToDate) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/projectlist", {
      flag: "timeSheetAddProject",
      parameters: {
        workspaceId: FromandToDate.FromandToDate.workspaceId,
        name: FromandToDate.FromandToDate.name,
        fromDate: FromandToDate.FromandToDate.fromDate,
        toDate: FromandToDate.FromandToDate.toDate,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addMemberTimesheetService = (receivedata) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet", {
      flag: "addMemberTimesheet",
      parameters: {
        projectId: receivedata.sendData.projectId,
        taskId: receivedata.sendData.taskId,
        workspaceId: receivedata.sendData.workspaceId,
        workDate: receivedata.sendData.workDate,
        workHours: receivedata.sendData.workHours,
        description: receivedata.sendData.description,
        tag: receivedata.sendData.tag,
        startTime: receivedata.sendData.startTime,
        endTime: receivedata.sendData.endTime,
        billable: receivedata.sendData.billable,
      entryType: receivedata.sendData.entryType,
      timesheetGroupId: receivedata.sendData.timesheetGroupId || "",
      // Optional: omitted means no phase; the server validates it against the project
      ...(receivedata.sendData.phaseId
        ? { phaseId: receivedata.sendData.phaseId }
        : {}),
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateTimesheetGroupDescriptionService = (receivedata) => {
  return axiosInstance
    .patch(MEMBER_URL + "/member/timesheet/group/description", {
      flag: "updateTimesheetGroupDescription",
      parameters: {
        timesheetGroupId: receivedata.sendData.timesheetGroupId,
        description: receivedata.sendData.description,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getMemberTimeSheetService = (receivedata) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/timesheet?flag=getMemberTimesheet&workspaceId=${receivedata.FromandToDate.workspaceId}&startDate=${receivedata.FromandToDate.fromDate}&endDate=${receivedata.FromandToDate.toDate}`,
    )
    .then((response) => {
      return response.data;
    });
};
export const getMyApprovalTimesheetModalService = (receivedata) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/timesheet/ForApproval?workspaceId=${receivedata.FromandToDate.workspaceId}&flag=getMemberTimesheetForApproval&memberId=${receivedata.FromandToDate.memberId}&projectId=${receivedata.FromandToDate.projectId}&entryType=${receivedata.FromandToDate.entryType}&startDate=${receivedata.FromandToDate.startDate}&endDate=${receivedata.FromandToDate.endDate}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const deleteMemberTimeSheetService = (receivedata) => {
  return axiosInstance
    .patch(
      `${MEMBER_URL}/member/timesheet?flag=deleteMemberTimeSheet&workspaceId=${receivedata.sendData.workspaceId}&projectId=${receivedata.sendData.projectId}&projectTaskId=${receivedata.sendData.taskId}&fromDate=${receivedata.sendData.fromDate}&toDate=${receivedata.sendData.toDate}&billable=${receivedata.sendData.billable}&entryType=${receivedata.sendData.entryType}&timesheetId=${encodeURIComponent(receivedata.sendData.timesheetId || "")}&timesheetGroupId=${encodeURIComponent(receivedata.sendData.timesheetGroupId || "")}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateTimeSheetHoursService = (receivedata) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/edittime", {
      flag: "updateTimeSheetHours",
      parameters: {
        projectId: receivedata.sendData.projectId,
        projectTaskId: receivedata.sendData.projectTaskId,
        workspaceId: receivedata.sendData.workspaceId,
        timesheetId: receivedata.sendData.timesheetId,
        timesheetGroupId: receivedata.sendData.timesheetGroupId || "",
        timesheetDate: receivedata.sendData.timesheetDate,
        workHours: receivedata.sendData.workHours,
        billable: receivedata.sendData.billable,
        entryType: receivedata.sendData.entryType,
        // Optional: omitted retains the row's current phase
        ...(receivedata.sendData.phaseId
          ? { phaseId: receivedata.sendData.phaseId }
          : {}),
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const departmentListService = (workspaceId) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/department?flag=getDepartment&workspaceId=${workspaceId}&getBy=name&value=${""}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getAllCustomerListService = (workspaceId) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/customer/getall?flag=getAllCustomer&workspaceId=${workspaceId}&search`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateTimeSheetProjectService = (receivedata) => {
  const params = new URLSearchParams({
    flag: "updateTimeSheetProject",
    prevProjectTaskId: receivedata.sendData.pandtID,
    projectId: receivedata.sendData.projectId,
    projectTaskId: receivedata.sendData.projectTaskID || "",
    workspaceId: receivedata.sendData.workspaceID,
    fromDate: receivedata.sendData.startdate,
    toDate: receivedata.sendData.enddate,
    billableStatus: receivedata.sendData.billableStatus,
    entryType: receivedata.sendData.entryType || "",
  });
  // Optional: the server re-derives customer and resolves/clears the phase for the new project
  if (receivedata.sendData.phaseId) {
    params.append("phaseId", receivedata.sendData.phaseId);
  }

  return axiosInstance
    .patch(`${MEMBER_URL}/member/timesheet/editproject?${params.toString()}`)
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryService = (sendData) => {
  return axiosInstance
    .post(REPORT_URL, {
      flag: "reportSummary",
      parameters: {
        workspaceId: sendData.workspaceID,
        dateFrom: sendData.dateFrom,
        dateTo: sendData.dateTo,
        groupIds: sendData.groupIds,
        memberIds: sendData.memberIds,
        departmentIds: sendData.departmentIds,
        projectIds: sendData.projectIds,
        taskIds: sendData.taskIds,
        billstatus: sendData.billStatus,
        orderBy: sendData.orderBy,
        sortBy: sendData.sortBy,
        limit: sendData.limit,
        page: sendData.page,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const reportGetListService = (workspaceId) => {
  return axiosInstance
    .get(
      `${REPORT_URL}/getReportsList?flag=getReportsList&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const workspaceForecastReportService = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/workspaceForecastReport", payload)
    .then((response) => {
      return response.data;
    });
};

export const budgetRevenueOverallExportService = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/budgetRevenueOverallExport", payload)
    .then((response) => {
      return response.data;
    });
};

export const projectStatusReportService = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/projectStatus", payload)
    .then((response) => {
      return response.data;
    });
};


export const yearlyWorkspaceMembersUtilizationService = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/yearlyWorkspaceMembersUtilization", payload)
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryCsvService = (sendData) => {
  return axiosInstance
    .post(REPORT_URL, {
      flag: "reportSummaryExport",
      parameters: sendData,
    })
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryGraphsService = (sendData) => {
  return axiosInstance
    .post(REPORT_URL + "/Bargraph", {
      flag: "reportSummaryGraphs",
      parameters: {
        workspaceId: sendData.workspaceID,
        dateFrom: sendData.dateFrom,
        dateTo: sendData.dateTo,
        reportType: "",
        billstatus: sendData.billStatus,
        memberIds: sendData.memberIds,
        projectIds: sendData.projectIds,
        taskIds: sendData.taskIds,
        departmentIds: sendData.departmentIds,
        groupIds: sendData.groupIds,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryGraphService = (payload, flag, endpoint) => {
  return axiosInstance
    .post(endpoint, {
      flag: flag,
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const createSessionService = (
  name,
  idWorkspace,
  startDate,
  endDate,
  surveyId,
  categoryId,
) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session", {
      flag: "createSession",
      parameters: {
        name: name,
        idWorkspace: idWorkspace,
        startDate: startDate,
        endDate: endDate,
        surveyId: surveyId,
        categoryId: categoryId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getokrAlignment = (idSession, tags, ownerIds, departmentIds) => {
  return axiosInstance
    .post(OKR_URL + "/objective/allignment", {
      flag: "getOrganisationOKRAllignment",
      parameters: {
        idSession: idSession,
        tags: tags,
        ownerIds: ownerIds,
        departmentIds: departmentIds,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const searchSessionService = (
  value,
  idWorkspace,
  page,
  posts,
  sortby,
  Status,
) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session/search", {
      flag: "searchSession",
      parameters: {
        workspaceId: idWorkspace,
        name: value,
        page: page,
        limit: posts,
        sortby: sortby,
        orderby: Status,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteSessionService = (idSession) => {
  return axiosInstance
    .delete(
      `${OKR_URL}/objective/session?sessionId=${idSession}&flag=deleteSession`,
    )
    .then((response) => {
      return response.data;
    });
};
export const updateSessionService = (
  idSession,
  name,
  idWorkspace,
  start,
  end,
  trackingStatus,
  surveyId,
  categoryId,
) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session/edit", {
      flag: "editSession",
      parameters: {
        idSession: idSession,
        name: name,
        idWorkspace: idWorkspace,
        startDate: start,
        endDate: end,
        trackingStatus: trackingStatus,
        surveyId: surveyId,
        categoryId: categoryId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getObjectiveUserLogsService = (idObjective) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective?flag=getObjectiveStatusUpdateLogs&idObjective=${idObjective}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const setCurrentService = (idSession) => {
  return axiosInstance
    .patch(
      `${OKR_URL}/objective/session/setcurrent?sessionId=${idSession}&flag=setCurrentSession`,
    )
    .then((response) => {
      return response.data;
    });
};
export const getSessionService = (workspaceID) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/session?flag=getSession&sessionId=&workspaceId=${workspaceID}&search`,
    )
    .then((response) => {
      return response.data;
    });
};
export const getSessionServiceAll = (workspaceID) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/session?flag=getSession&sessionId=&workspaceId=${workspaceID}&status=getAll&search`,
    )
    .then((response) => {
      return response.data;
    });
};
export const findObjectiveService = (receivedata, idObjective, search) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/find?flag=findObjective&objectiveId=&search=${search ? search : ""
      }&sessionId=${receivedata}&notInObjectiveId=${idObjective}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getWorkspaceMemberOKRService = (workspaceID, memberID) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/workspaces/get?flag=getWorkspaceMember&workspaceId=${workspaceID}&memberId=${memberID}&search=`,
    )
    .then((response) => {
      return response.data;
    });
};

//Feedback & MOM
export const getFeedbackService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/feedback/getall`, {
      flag: "getAllObjectiveFeedbacks",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteFeedbackService = (id) => {
  return axiosInstance
    .delete(
      `${OKR_URL}/objective/feedback/delete?flag=deleteObjectiveFeedback&objectiveFeedbackId=${id}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const updateFeedbackService = (flag, id) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/updateActionitem?idfeedbackActionItem=${id}&achieved=${flag}&flag=updateActionItems`,
    )
    .then((res) => {
      return res.data;
    });
};

export const addFeedbackService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/feedback/add`, {
      flag: "addObjectiveFeedback",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const editFeedbackService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/feedback/edit`, {
      flag: "editObjectiveFeedback",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
export const createObjectiveService = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective", {
      flag: "createObjective",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const objectiveMultiSearchService = () => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/multiple/search?flag=objectiveMultiSearch&search=`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getObjectiveService = (idObjective) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective?flag=getObjective&idObjective=4f6a5362-82b9-4819-9d58-af07c227c009`,
    )
    .then((response) => {
      return response.data;
    });
};

export const customerStatusService = (
  customerId,
  status,
  workspaceId,
  value,
) => {
  return axiosInstance
    .patch(
      `${ADMIN_URL}/update/customer/status?flag=updateCustomerStatus&customerId=${customerId}&status=${status}&workspaceId=${workspaceId}&isDisableProject=${value}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const editBillableService = (id, workspaceID, value, startDateTime) => {
  return axiosInstance
    .post(
      `${PROJECT_URL}/admin/project/access/memberandgroup/edit?flag=editProjectAccess&id=${id}&accessType=member&workspaceId=${workspaceID}&billableRate=${value}&startDateTime=${startDateTime}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const editWorkHourService = (id, workspaceID, value) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/admin/project/edit/workhours?flag=editProjectMemberWrkHour&id=${id}&workspaceId=${workspaceID}&workHours=${value}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const editProfileService = (
  firstName,
  lastName,
  countryCode,
  phone,
  email,
  oldPassword,
  newPassword,
  confirmPassword,
  avatar,
) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "editProfile",
      parameters: {
        firstname: firstName,
        lastname: lastName,
        countryCode: countryCode,
        phone: phone,
        newEmail: email,
        confirmEmail: email,
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
        avatar: avatar,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addReminderService = (
  configurationtype,
  workspaceID,
  reminderType,
  limitType,
  hours,
  groupId,
  memberId,
  days,
  memberType,
  customerId,
  projectId,
) => {
  return axiosInstance
    .post(REMINDER_URL + "/reminder/add", {
      flag: "addReminder",
      parameters: {
        workspaceId: workspaceID,
        memberType: memberType,
        reminderType: reminderType,
        limitType: limitType,
        hours: hours,
        groupIds: groupId,
        memberIds: memberId,
        days: days,
        configurationtype: configurationtype,
        customerIds: customerId,
        projectIds: projectId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editReminderService = (
  configurationtype,
  workspaceID,
  reminderType,
  limitType,
  hours,
  groupId,
  memberId,
  days,
  memberType,
  customerId,
  projectId,
  reminderRequestId,
) => {
  return axiosInstance
    .post(REMINDER_URL + "/reminder/edit", {
      flag: "editReminder",
      parameters: {
        reminderRequestId: reminderRequestId,
        workspaceId: workspaceID,
        reminderType: reminderType,
        limitType: limitType,
        hours: hours,
        groupIds: groupId,
        memberIds: memberId,
        days: days,
        configurationtype: configurationtype,
        projectIds: projectId,
        customerIds: customerId,
        memberType: memberType,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getReminderListService = (workspaceID, value) => {
  return axiosInstance
    .get(
      `${REMINDER_URL}/reminder/fetch?flag=getReminderList&workspaceId=${workspaceID}&configurationtype=${value}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const deleteReminderService = (reminderId) => {
  return axiosInstance
    .patch(
      `${REMINDER_URL}/reminder/delete?flag=deleteReminder&reminderRequestId=${reminderId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getReportUsersService = (workspaceID) => {
  return axiosInstance
    .post(REMINDER_URL + "/reminder/users?flag=getReportUsers", {
      flag: "getReportUsers",
      parameters: {
        workspaceId: workspaceID,
        isActive: 1,
        search: "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getSearchReportUsersService = (workspaceID, isActive, search) => {
  return axiosInstance
    .post(REMINDER_URL + "/reminder/users?flag=getReportUsers", {
      flag: "getReportUsers",
      parameters: {
        workspaceId: workspaceID,
        isActive: isActive,
        search: search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryUsersService = (workspaceID) => {
  return axiosInstance
    .post(REPORT_URL + "/users", {
      flag: "reportSummaryUsers",
      parameters: {
        workspaceId: workspaceID,
        isActive: true,
        search: "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const reportWeeklyTimesheetReportService = (workspaceId) => {
  return axiosInstance
    .get(
      `${REPORT_URL}/getMembersDropdown?flag=getMembersListDropdown&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const reportSearchSummaryUsers = (workspaceID, isActive, search) => {
  return axiosInstance
    .post(REPORT_URL + "/users", {
      flag: "reportSummaryUsers",
      parameters: {
        workspaceId: workspaceID,
        isActive: true,
        search: search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryProjectsService = (
  workspaceID,
  select_dep,
  module,
  projectStatus,
) => {
  const parameters = {
    workspaceId: workspaceID,
    departmentIds: select_dep,
    search: "",
    isActive: true,
    module: module,
  };

  if (projectStatus && projectStatus.toUpperCase() !== "ALL") {
    parameters.projectStatus = projectStatus;
  }

  return axiosInstance
    .post(REPORT_URL + "/projects", {
      flag: "reportSummaryProjects",
      parameters: parameters,
    })
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryTasksService = (workspaceID, select_Project) => {
  return axiosInstance
    .post(REPORT_URL + "/tasks", {
      flag: "reportSummaryTasks",
      parameters: {
        workspaceId: workspaceID,
        projectIds: select_Project,
        isActive: "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryDepartmentsService = (workspaceID, isActive = "active") => {
  return axiosInstance
    .post(REPORT_URL + "/departments", {
      flag: "reportSummaryDepartments",
      parameters: {
        workspaceId: workspaceID,
        isActive: isActive,
        search: "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addMemberTimetrackerService = (
  projectId,
  taskId,
  workspaceId,
  workDate,
  description,
  tag,
  startTime,
  billable,
  entryType,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timetracker", {
      flag: "addMemberTimetracker",
      parameters: {
        projectId,
        taskId,
        workspaceId,
        workDate,
        description,
        tag,
        startTime,
        billable,
        entryType,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editMemberTimetrackerService = (
  id,
  workHours,
  description,
  projectId,
  taskId,
  workspaceId,
  entryType,
  billable,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timetracker/edit", {
      flag: "editMemberTimetracker",
      parameters: {
        id: id,
        workHours: workHours,
        description: description,
        projectId: projectId,
        taskId: taskId,
        workspaceId: workspaceId,
        entryType: entryType,
        billable: billable,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const changeMemberManagerService = (
  workspaceId,
  managerId,
  memberId,
) => {
  return axiosInstance
    .patch(MEMBER_URL + "/member/assignManager", {
      flag: "changeMemberManager",
      parameters: {
        workspaceId,
        managerId,
        memberId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getFinancierMembers = (workspaceId, memberId) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/financierMembers", {
      flag: "financierDropDown",
      parameters: {
        workspaceId,
        memberId,
      },
    })
    .then((response) => response.data);
};


export const managerDropDownService = (
  workspaceId,
  memberId,
  search,
  fetchFor,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/reportManagers", {
      flag: "managerDropDown",
      parameters: {
        workspaceId: workspaceId,
        memberId: memberId,
        search: search,
        fetchFor: fetchFor,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const assignOtherManagerService = (
  workspaceId,
  oldManagerId,
  newManagerId,
) => {
  return axiosInstance
    .patch(MEMBER_URL + "/member/assign/manager", {
      flag: "assignOtherManager",
      parameters: {
        workspaceId,
        oldManagerId,
        newManagerId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const memberApproveService = (memberList, reportStatus, comments) => {
  return axiosInstance
    .patch(MEMBER_URL + "/member/update/approveStatus", {
      flag: "updateApproveStatus",
      parameters: {
        memberList: memberList,
        reportStatus: reportStatus,
        comments: comments,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const memberExpenseApproveService = (
  idWorkspace,
  status,
  expenseIDs,
  comments,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/selected/approval", {
      flag: "approveorrejectExpenses",
      parameters: {
        idWorkspace,
        expenseIDs,
        status,
        comments,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addDynamicFieldService = (senddata) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/customfield", {
      flag: "addDynamicField",
      parameters: {
        workspaceId: senddata.workspace_id,
        moduleType: senddata.module_,
        fieldName: senddata.name_,
        fieldType: senddata.fieldType_,
        fieldValue: senddata.optionfield_,
        fieldMandatory: senddata.checked,
        includeinreport: senddata.includeinreport,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateFieldStatusService = (senddataDel) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/customfield", {
      flag: "updateFieldStatus",
      parameters: {
        fieldId: senddataDel.field_Id,
        workspaceId: senddataDel.workspace_Id,
        status: senddataDel.status,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getDynamicFieldsService = (
  workspaceID,
  memberId,
  projectId,
  module,
) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/setting/getdynamicfields?flag=GetDynamicFields&workspaceId=${workspaceID}&projectId=${projectId}&memberId=${memberId}&module=${module}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const saveDynamicFieldsService = (
  workspaceId,
  projectId,
  memberId,
  configurationId,
  dynamicfieldId,
  module,
  values,
) => {
  return axiosInstance
    .post(PROJECT_URL + "admin/setting/savedynamicfields", {
      flag: "SaveDynamicFields",
      parameters: {
        workspaceId: workspaceId,
        projectId: projectId,
        memberId: memberId,
        configurationId: configurationId,
        dynamicfieldId: dynamicfieldId,
        module: module,
        values: values,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getCustomFieldService = (getsingledata) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/customfield", {
      flag: "getCustomField",
      parameters: {
        fieldId: getsingledata.field_Id,
        workspaceId: getsingledata.workspace_Id,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateDynamicFieldService = (senddata) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/customfield", {
      flag: "updateDynamicField",
      parameters: {
        fieldId: senddata.editfield_Id,
        workspaceId: senddata.workspace_id,
        moduleType: senddata.module_edit,
        fieldName: senddata.name_edit,
        fieldType: senddata.fieldType_edit,
        fieldValue: senddata.optionfield_edit,
        fieldMandatory: senddata.checked_edit,
        includeinreport: senddata.isCheckedReport,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const searchCustomFieldService = (getTableData) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/setting/search/dynamicfields", {
      flag: "searchCustomField",
      parameters: {
        workspaceId: getTableData.workspace_Id,
        search: "",
        orderBy: getTableData.orderBy,
        sortBy: getTableData.sortBy,
        limit: getTableData.limit,
        page: getTableData.page,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getTaskTemplateService = (getTableData) => {
  return axiosInstance
    .post(PROJECT_URL + "/template/gettask", {
      flag: "getTaskTemplate",
      parameters: {
        workspaceId: getTableData.workspace_Id,
        responseType: getTableData.responseType,
        search: getTableData.search,
        orderBy: getTableData.orderBy,
        sortBy: getTableData.sortBy,
        page: getTableData.page,
        limit: getTableData.limit,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateTemplateStatusService = (senddataDel) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/template/task/status?flag=updateTemplateStatus&workspaceId=${senddataDel.workspace_Id}&templateId=${senddataDel.templateId}&status=${senddataDel.status}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const createTaskTemplateService = (senddata) => {
  return axiosInstance
    .post(PROJECT_URL + "/project/task/create/template", {
      flag: "CreateTaskTemplate",
      parameters: {
        workspaceid: senddata.workspace_Id,
        templateName: senddata.taskTemplate_Name,
        taskname: senddata.taskName,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const createProjectTemplateWithReleasesService = (payload) => {
  return axiosInstance
    .post(PROJECT_URL + "/template/createproject", {
      flag: "CreateProjectTemplate",
      parameters: {
        workspaceId: payload.workspaceId,
        templateName: payload.templateName,
        description: payload.description || "",
        releases: payload.releases || [],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getProjectPhaseTemplateService = (workspaceId, search = "") => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project", {
      flag: "getProjectPhaseTemplate",
      parameters: {
        workspaceId,
        responseType: "dropDown",
        search: search || "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getProjectPhaseTemplateByIdService = (workspaceId, templateId) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project", {
      flag: "getProjectPhaseTemplate",
      parameters: {
        workspaceId,
        templateId,
        responseType: "getbyId",
      },
    })
    .then((response) => response.data);
};

export const editProjectPhaseTemplateService = (payload) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project", {
      flag: "editProjectPhaseTemplate",
      parameters: {
        workspaceId: payload.workspaceId,
        templateId: payload.templateId,
        phaseTemplateName: payload.phaseTemplateName,
        phases: payload.phases || [],
      },
    })
    .then((response) => response.data);
};

export const deleteProjectPhaseTemplateService = (workspaceId, templateId) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project", {
      flag: "deleteProjectPhaseTemplate",
      parameters: {
        workspaceId,
        templateId,
      },
    })
    .then((response) => response.data);
};

export const saveProjectPhaseTemplateService = (payload) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project", {
      flag: "saveProjectPhaseTemplate",
      parameters: {
        workspaceId: payload.workspaceId,
        phaseTemplateName: payload.phaseTemplateName,
        phases: payload.phases || [],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getProjectTemplateService = (workspaceID, type, templateId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/template/getproject?flag=getProjectTemplate&workspaceId=${workspaceID}&responseType=${type}&templateId=${templateId}&search=`,
    )
    .then((response) => {
      return response.data;
    });
};

export const ImportTaskTemplateService = (
  workspaceid,
  projectid,
  departmentid,
  templateid,
  taskTagMappings = [],
) => {
  return axiosInstance
    .post(PROJECT_URL + "/project/task/Import/template", {
      flag: "ImportTaskTemplate",
      parameters: {
        workspaceid,
        projectid,
        departmentid,
        templateid,
        taskTagMappings,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const approvalListService = (
  managerid,
  sortBy,
  page,
  posts,
  workspaceid,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/Get/MembersListForApproval", {
      flag: "MembersApprovalList",
      parameters: {
        managerid: managerid,
        search: "",
        orderBy: "",
        sortBy: sortBy,
        limit: posts,
        page: page,
        workspaceid: workspaceid,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getCustomersService = (workspaceID, isActive = "active") => {
  return axiosInstance
    .post(REMINDER_URL + "/reminder/customers", {
      flag: "getCustomers",
      parameters: {
        workspaceId: workspaceID,
        search: "",
        isActive: isActive,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getProjectsService = (workspaceID) => {
  return axiosInstance
    .post(REMINDER_URL + "/reminder/projects", {
      flag: "getProjects",
      parameters: {
        workspaceId: workspaceID,
        search: "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const copyLastWeekTsService = (copylastweekdates) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/copylastweek", {
      flag: "copyLastWeekTs",
      parameters: {
        workspaceId: copylastweekdates.workspaceId,
        fromDate: copylastweekdates.fromDate,
        toDate: copylastweekdates.toDate,
        copyTimeStatus: copylastweekdates.copyTimeStatus,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addTsTemplateService = (addTsTemplateDate) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/addtemplate", {
      flag: "addTsTemplate",
      parameters: {
        workspaceId: addTsTemplateDate.workspaceId,
        name: addTsTemplateDate.name,
        fromDate: addTsTemplateDate.fromDate,
        toDate: addTsTemplateDate.toDate,
        includeTime: addTsTemplateDate.includeTime,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getTsTemplateService = (getTsTemplateDate) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/gettemplate", {
      flag: "getTsTemplate",
      parameters: {
        workspaceId: getTsTemplateDate.workspaceId,
        search: getTsTemplateDate.search,
        orderBy: getTsTemplateDate.orderBy,
        sortBy: getTsTemplateDate.sortBy,
        limit: getTsTemplateDate.limit,
        page: getTsTemplateDate.page,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateTsTemplateService = (updateTsTemplateData) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/updatetemplate", {
      flag: "updateTsTemplate",
      parameters: {
        workspaceId: updateTsTemplateData.workspaceId,
        templateId: updateTsTemplateData.templateId,
        templateName: updateTsTemplateData.templateName,
        status: updateTsTemplateData.status,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const activateTemplateService = (activeTemplateData) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/usetemplate", {
      flag: "activateTemplate",
      parameters: {
        workspaceId: activeTemplateData.workspaceId,
        templateId: activeTemplateData.templateId,
        fromDate: activeTemplateData.fromDate,
        toDate: activeTemplateData.toDate,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getCurrencyService = (workspace_Id, inr) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/workspace/currency?workspaceId=${workspace_Id}&search=${""}&flag=getCurrency`,
    )
    .then((response) => {
      return response.data;
    });
};

export const sendInstantReminderAction = async (sendInstantReminderPayload) => {
  const response = await axiosInstance.post(INVOICE_URL + "/invoice/remind", {
    flag: "remindInvoice",
    parameters: {
      id: sendInstantReminderPayload.id,
      multipleInvoiceFlag: sendInstantReminderPayload.multipleInvoiceFlag,
    },
  });
  return response.data;
};

export const getInvoiceDetailsService = (sendAllData) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/getWorkspaceInvoiceList", {
      flag: "getInvoiceDetails",
      parameters: {
        workSpaceId: sendAllData.workSpaceId,
        search: sendAllData.search,
        orderBy: sendAllData.orderBy,
        sortBy: sendAllData.sortBy,
        limit: sendAllData.limit,
        page: sendAllData.page,
        createstartdate: sendAllData.createstartdate,
        createenddate: sendAllData.createenddate,
        statuslist: sendAllData.statuslist,
        customerids: sendAllData.customerids,
        projectids: sendAllData.projectids,
        needToExport: sendAllData.export,
        exportFromat: sendAllData.format,
        currencyType: sendAllData.currencyType,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getInvoiceCurrenciesService = (workspaceId) => {
  return axiosInstance
    .get(
      `${INVOICE_URL}/invoice/getCurrenciesList?flag=getCurrenciesList&workSpaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getInvoiceStatisticsGraphService = (payload) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/getInvoiceStatisticsGraph", {
      flag: "getInvoiceStatisticsGraph",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getInvoiceDetailsPopupService = (payload) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/getInvoiceDetailsForPopUp", {
      flag: "getInvoiceDetailsForPopUp",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getTotalInvoiceDataService = (payload) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/getWorkspaceInvoiceListDashboard", {
      flag: "getInvoiceDetailsDashboard",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getInvoicePhasesService = (projectId) => {
  return axiosInstance
    .get(
      `${INVOICE_URL}/invoice/project/phases?projectId=${projectId}&flag=getProjectPhases`,
    )
    .then((response) => response.data);
};

export const createInvoiceService = (
  workSpaceId,
  projectId,
  customerId,
  invoiceType,
  recurringPeriod,
  stopDate,
  billingstartdate,
  billingendtdate,
  invoicelogo,
  idContractor,
  templateId,
  selectedPhaseIds,
) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/create", {
      flag: "add",
      parameters: {
        id: "",
        workSpaceId: workSpaceId,
        projectId: projectId,
        customerId: customerId,
        flowtype: "save invoice",
        invoiceType: invoiceType,
        recurringPeriod: recurringPeriod,
        stopDate: stopDate,
        billingstartdate: billingstartdate,
        billingenddate: billingendtdate,
        invoicelogo: invoicelogo,
        idContractor: idContractor,
        templateId: templateId,
        selectedPhaseIds: selectedPhaseIds ?? [],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getInvoiceSettingService = (workspaceID) => {
  return axiosInstance
    .get(`${INVOICE_URL}/invoice/setting?flag=get&workSpaceId=${workspaceID}`)
    .then((response) => {
      return response.data;
    });
};

export const saveInvoiceSettingService = (
  lateFeesPercentage,
  taxRatePercentage,
  dueDays,
  taxNumber,
  note,
  mailBody,
  subject,
  workspaceID,
  discount,
  reminderdays,
  lineitemcode,
  lineitemdescription,
  ccemail,
  bccemail,
  fromaddress,
  fromemail,
) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/setting/savechanges", {
      flag: "add",
      parameters: {
        workSpaceId: workspaceID,
        lateFeesPercentage: lateFeesPercentage,
        taxRatePercentage: taxRatePercentage,
        dueDays: dueDays,
        taxNumber: taxNumber,
        note: note,
        mailBody: "",
        subject: subject,
        paymentDetails: mailBody,
        discount: discount,
        reminderdays: reminderdays,
        lineitemcode: lineitemcode,
        lineitemdescription: lineitemdescription,
        ccemail: ccemail,
        bccemail: bccemail,
        fromaddress: fromaddress,
        fromemail: fromemail,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getEmailLogService = (invoiceIds, workSpaceId) => {
  return axiosInstance
    .get(
      `${INVOICE_URL}/invoice/getEmailLog?flag=getEmailLog&invoiceId=${invoiceIds}&workSpaceId=${workSpaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getAuditLogService = (id, workSpaceId) => {
  return axiosInstance
    .post(
      `${INVOICE_URL}/invoice/getHistory?flag=getHistory&id=${id}&workSpaceId=${workSpaceId}`,
    )
    .then((res) => {
      return res.data;
    });
};
export const getOkrAuditLogService = (id) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/getauditlog?flag=getObjectiveLogs&idObjective=${id}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const getOkrTagsService = (
  idWorkspace,
  page,
  limit,
  search,
  sortby,
  order,
) => {
  return axiosInstance
    .post(OKR_URL + "/tag/get", {
      flag: "getTagsList",
      parameters: {
        idWorkspace,
        page,
        limit,
        search,
        sortby,
        order,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const createOkrTagsService = (
  idWorkspace,
  tagName,
  backgroundColor,
  borderColor,
) => {
  return axiosInstance
    .post(OKR_URL + "/tag/create", {
      flag: "createTags",
      parameters: {
        idWorkspace,
        tagName,
        backgroundColor,
        borderColor,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateOkrTagsService = (idWorkspace, id, tagName) => {
  return axiosInstance
    .post(OKR_URL + "/tag/edit", {
      flag: "editTag",
      parameters: {
        idWorkspace,
        id,
        tagName,
      },
    })
    .then((response) => {
      return response.data;
    });
};
export const getSingleInvoiceDetailsService = (invoiceIds) => {
  return axiosInstance
    .get(`${INVOICE_URL}/invoice/get?flag=getInvoiceDetails&id=${invoiceIds}`)
    .then((response) => {
      return response.data;
    });
};

export const deleteInvoiceService = (invoiceIds, workSpaceId) => {
  return axiosInstance
    .delete(
      `${INVOICE_URL}/invoice/delete?flag=delete&id=${invoiceIds}&workSpaceId=${workSpaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const duplicateInvoiceService = (invoiceIds, workSpaceId) => {
  return axiosInstance
    .post(
      `${INVOICE_URL}/invoice/duplicate?flag=add&id=${invoiceIds}&workSpaceId=${workSpaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const markInvoiceAsVoidService = (id, workSpaceId) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/MarkInvoiceAsVoid", {
      flag: "markInvoiceAsVoid",
      parameters: {
        id: id,
        workSpaceId: workSpaceId,
      },
    })
    .then((response) => response.data);
};


export const markUsPaidService = (
  invoiceId,
  paymentMethod,
  paidAmount,
  paidDate,
  note,
  notifyAsInvoice,
  Arrayt,
  workspaceId,
) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/MarkInvoiceAsPaid", {
      flag: "add",
      parameters: {
        invoiceId: invoiceId,
        paymentMethod: paymentMethod,
        paidAmount: paidAmount,
        paidDate: paidDate,
        note: note,
        notifyAsInvoice: notifyAsInvoice,
        invoiceAttachmentV2: "",
        files: Arrayt,
        workspaceId: workspaceId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const downloadInvoiceService = (id) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/download", {
      flag: "add",
      parameters: {
        id: id,
        flowtype: "download invoice",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const recurringDetailesService = (invoiceIDS, workSpaceId) => {
  return axiosInstance
    .post(
      `${INVOICE_URL}/invoice/getrecurringdetail?flag=add&id=${invoiceIDS}&workSpaceId=${workSpaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const stopRecurringService = (invoice_id, workSpaceId) => {
  return axiosInstance
    .patch(
      `${INVOICE_URL}/invoice/stopAutoRepeat?invoiceId=${invoice_id}&workSpaceId=${workSpaceId}&flag=stop`,
    )
    .then((response) => {
      return response.data;
    });
};

export const EditInvoiceService = (
  editedData,
  bccEmail,
  ccEmail,
  mailsubject,
  mailbody,
  toEmail,
  memberBillrateValidation,
) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/send", {
      flag: "add",
      parameters: {
        id: editedData.id,
        workSpaceId: editedData.workSpaceId,
        projectId: editedData.projectId,
        customerId: editedData.customerId,
        flowtype: editedData.flowtype,
        invoiceType: editedData.invoiceType,
        fromAddress: editedData.fromAddress,
        fromEmail: editedData.fromEmail,
        toEmail: toEmail || editedData.toEmail,
        logoImgType: editedData.logoImgType,
        backgroundImgType: editedData.backgroundImgType,
        issuedOn: editedData.issuedOn,
        dueDate: editedData.dueDate,
        subTotal: editedData.subTotal,
        discount: editedData.discount,
        tax: editedData.tax,
        totalAmt: editedData.totalAmt,
        lateFees: editedData.lateFees,
        taxNumber: editedData.taxNumber,
        note: editedData.note,
        toAddress: editedData.toAddress,
        paymentinformation: editedData.paymentinformation,
        backgroundBase64: editedData.backgroundBase64,
        logoBase64: editedData.logoBase64,
        fromname: editedData.fromname,
        toname: editedData.toname,
        discountpercent: editedData.discountpercent,
        taxpercent: editedData.taxpercent,
        amountformat: editedData.amountformat,
        lineitemedited: editedData.lineitemedited,
        invoiceAttachments: editedData.invoiceAttachments,
        invoiceLineItems: editedData.invoiceLineItems,
        latefeepercent: editedData.latefeepercent,
        attachementRequestList: editedData.attachementRequestList,
        billingstartdate: editedData.billingstartdate,
        billingenddate: editedData.billingenddate,
        recurringPeriod: editedData.recurringPeriod,
        bccEmail: bccEmail,
        ccEmail: ccEmail,
        mailsubject: mailsubject,
        mailbody: mailbody,
        backgroundimagedeleted: editedData.backgroundimagedeleted,
        logodeleted: editedData.logodeleted,
        hidereceipientmail: editedData.hidereceipientmail,
        signdeleted: editedData?.signdeleted,
        memberBillrateValidation: memberBillrateValidation,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const uploadAttachService = (base64, fileType) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/FileUpload", {
      flag: "add",
      parameters: {
        files: [
          {
            fileType: fileType,
            base64: base64,
          },
        ],
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const scheduleLaterService = (scheduleLaterData) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/schedule/ondate", {
      flag: "add",
      parameters: {
        id: scheduleLaterData.id,
        reminderenable: scheduleLaterData.reminderenable,
        invoiceType: scheduleLaterData.invoiceType,
        mailsubject: scheduleLaterData.mailsubject,
        mailbody: scheduleLaterData.mailbody,
        onDate: scheduleLaterData.onDate,
        bccEmail: scheduleLaterData.bccEmail,
        ccEmail: scheduleLaterData.ccEmail,
        toEmail: scheduleLaterData.toEmail,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateLogoService = (id, logoType, logo) => {
  return axiosInstance
    .patch(ADMIN_URL + "/workspace/setfield", {
      flag: "updateWorkspace",
      parameters: {
        id: id,
        logoUpdateFlag: "true",
        logoType: logoType,
        logo: logo,
        defaultBillRate: 0,
        geoLocationStatus: false,
        okrNotificationsEnabled: false,
        expense_notifications_enabled: false,
      },
    })
    .then((response) => {
      return response.data;
    });
};

//Favourite OKR
export const addOKRFavouriteService = (payload) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/favourite", {
      flag: "setAsFavourite",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteOKRFavouriteService = (id) => {
  return axiosInstance
    .patch(
      `${ADMIN_URL}/workspace/favourite?flag=removeAsFavourite&id=${id}&status=false`,
    )
    .then((response) => {
      return response.data;
    });
};

export const addEmailLogService = (id, flowtype) => {
  return axiosInstance
    .post(
      `${INVOICE_URL}/invoice/AddEmailLog?flag=AddEmailLog&invoiceId=${id}&flowtype=${flowtype}`,
    )
    .then((response) => {
      return response.data;
    });
};

/*==========Unlock and Lock patch method code start here==========*/
export const unlockAndLockService = (invoiceId, unlockStatus) => {
  return axiosInstance
    .patch(
      `${INVOICE_URL}/invoice/unlockedit?flag=unlockInvoice&invoiceId=${invoiceId}&unlockStatus=${unlockStatus}`,
    )
    .then((response) => {
      return response.data;
    });
};
/*==========Unlock and Lock patch method code end here==========*/

export const deleteAddAttachmentService = (delete_id, workspaceId) => {
  return axiosInstance
    .delete(
      `${INVOICE_URL}/invoice/attachement/delete?flag=delete&attachementId=${delete_id}&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getSettingInvoiceDetailsService = (
  edit_invoiceid,
  billableStartDate,
  billableEndDate,
) => {
  return axiosInstance
    .get(
      `${INVOICE_URL}/invoice/getv2?flag=add&id=${edit_invoiceid}&billingstartdate=${billableStartDate}&billingenddate=${billableEndDate}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const reportSummaryNewService = (sendData) => {
  return axiosInstance
    .post(REPORT_URL, {
      flag: "reportSummaryNew",
      parameters: sendData,
    })
    .then((response) => {
      return response.data;
    });
};

export const goalsReportSummaryService = (sendData) => {
  return axiosInstance
    .post(REPORT_URL + "/reportgeneration", {
      flag: "generateMemberSpecificOKRReport",
      parameters: sendData,
    })
    .then((response) => {
      return response.data;
    });
};
export const teamgoalsReportSummaryService = (sendData) => {
  return axiosInstance
    .post(REPORT_URL + "/OKRPerformance", {
      flag: "TeamOKRPerformanceSummaryReport",
      parameters: sendData,
    })
    .then((response) => {
      return response.data;
    });
};

export const OkrDepartmentWiseProgressReportService = (sendData) => {
  return axiosInstance
    .post(REPORT_URL + "/okr", {
      flag: "OkrDepartmentWiseProgressReport",
      parameters: sendData,
    })
    .then((response) => {
      return response.data;
    });
};

export const generateAttachementService = (
  invoiceId,
  workspaceId,
  projectId,
  billingstartdate,
  billingendate,
  invoicenumber,
) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/generateAttachement", {
      flag: "generateAttachement",
      parameters: {
        invoiceId: invoiceId,
        workspaceId: workspaceId,
        projectId: projectId,
        billingstartdate: billingstartdate,
        billingendate: billingendate,
        invoicenumber: invoicenumber,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getAllHolidayService = (workspaceID) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/leave/Holiday/getall", {
      flag: "getAllHoliday",
      parameters: {
        idWorkspace: workspaceID,
      },
    })
    .then((response) => {
      return response.data;
    });
};

/*==========timeOffBalanceExport post method code start here==========*/
export const timeOffBalanceExport = (timeoffpayloadexport) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/balance/report/export", {
      flag: "TimeoffBalanceExport",
      parameters: {
        idWorkspace: timeoffpayloadexport.idWorkspace,
        exportAs: timeoffpayloadexport.exportAs,
        limit: timeoffpayloadexport.limit,
        page: timeoffpayloadexport.page,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========timeOffBalanceExport post method code end here==========*/

export const createOrUpdateHolidayService = (
  idWorkspace,
  holidayName,
  occuresAnnually,
  memberIds,
  groupIds,
  period,
  forEveryone,
) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/leave/Holiday", {
      flag: "createOrUpdateHoliday",
      parameters: {
        idWorkspace: idWorkspace,
        holidayName: holidayName,
        occuresAnnually: occuresAnnually,
        memberIds: memberIds,
        groupIds: groupIds,
        period: period,
        forEveryone: forEveryone,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const EditHolidayService = (sendData) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/leave/Holiday", {
      flag: "createOrUpdateHoliday",
      parameters: {
        id: sendData.id,
        idWorkspace: sendData.idWorkspace,
        holidayName: sendData.holidayName,
        occuresAnnually: sendData.occuresAnnually,
        memberIds: sendData.memberIds,
        groupIds: sendData.groupIds,
        period: sendData.period,
        status: sendData.status,
        forEveryone: sendData.forEveryone,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const GetByIdService = (workspaceID, holidaysId) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/leave/Holiday/getbyid", {
      flag: "getById",
      parameters: {
        idWorkspace: workspaceID,
        id: holidaysId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getAllPolicyService = (workspaceID) => {
  return axiosInstance
    .post(
      `${TIMEOFF_URL}/LeavePolicy/getall?flag=getall&workspaceid=${workspaceID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const createPolicyService = (sendData) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/LeavePolicy/add?flag=add", {
      parameters: {
        workspace_id: sendData.workspace_id,
        policy_name: sendData.policy_name,
        members: sendData.members,
        groups: sendData.groups,
        time_unit: sendData.time_unit,
        approval_required: sendData.approval_required,
        accures_automatically: sendData.accures_automatically,
        accures_days: sendData.accures_days,
        accured_on: sendData.accured_on,
        allow_halfday: sendData.allow_halfday,
        allow_negativebalance: sendData.allow_negativebalance,
        limit_upto: sendData.limit_upto,
        limited_on: sendData.limited_on,
        limited: sendData.limited,
        approvers: sendData.approvers,
        approver_role: sendData.approver_role,
        for_everyone: sendData.for_everyone,
        negative_upto: sendData.negative_upto,
        auto_acquires_month: sendData.auto_acquires_month,
        resetBalanceEnabled: sendData.resetBalanceEnabled,
        resentMonth: sendData.resentMonth,
        defaultUnitValue: sendData.defaultUnitValue,
        flexi_leave: sendData.flexi_leave,
        flexi_allowed_dates: sendData.flexi_allowed_dates,
        flexi_allowed_count: sendData.flexi_allowed_count,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getBalanceService = (
  workspacId,
  idPolicy,
  idMember,
  getBy,
  orderBy,
  sortBy,
  limit,
  page,
) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/balance/report", {
      flag: "getTimeoffBalanceReport",
      parameters: {
        idWorkspace: workspacId,
        idPolicy: idPolicy,
        idMember: idMember,
        getBy: getBy,
        orderBy: orderBy,
        sortBy: sortBy,
        limit: limit,
        page: page,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deletePolicyService = (workspaceID, policyID) => {
  return axiosInstance
    .post(
      `${TIMEOFF_URL}/LeavePolicy/delete?flag=delete&workspaceid=${workspaceID}&id=${policyID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getSinglePolicyDetailesService = (workspaceID, policyID) => {
  return axiosInstance
    .post(
      `${TIMEOFF_URL}/LeavePolicy/getbyid?flag=get&workspaceid=${workspaceID}&id=${policyID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const editPolicyService = (sendData) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/LeavePolicy/edit?flag=edit", {
      parameters: {
        id: sendData.id,
        workspace_id: sendData.workspace_id,
        policy_name: sendData.policy_name,
        members: sendData.members,
        groups: sendData.groups,
        time_unit: sendData.time_unit,
        approval_required: sendData.approval_required,
        accures_automatically: sendData.accures_automatically,
        accures_days: sendData.accures_days,
        accured_on: sendData.accured_on,
        allow_halfday: sendData.allow_halfday,
        allow_negativebalance: sendData.allow_negativebalance,
        limit_upto: sendData.limit_upto,
        limited_on: sendData.limited_on,
        limited: sendData.limited,
        approvers: sendData.approvers,
        approver_role: sendData.approver_role,
        for_everyone: sendData.for_everyone,
        negative_upto: sendData.negative_upto,
        auto_acquires_month: sendData.auto_acquires_month,
        resetBalanceEnabled: sendData.resetBalanceEnabled,
        resentMonth: sendData.resentMonth,
        defaultUnitValue: sendData.defaultUnitValue,
        flexi_leave: sendData.flexi_leave,
        flexi_allowed_dates: sendData.flexi_allowed_dates,
        flexi_allowed_count: sendData.flexi_allowed_count,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getBalanceFilterMembersService = (workspaceId) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/balance/filtermembers", {
      flag: "getBalanceFilterMember",
      parameters: {
        idWorkspace: workspaceId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getHistoryService = (workspacId, idPolicy, idMember) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/balance/history", {
      flag: "getTimeOffHistory",
      parameters: {
        idWorkspace: workspacId,
        idPolicy: idPolicy,
        idMember: idMember,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const addOrLessService = (
  workspacId,
  idPolicy,
  idMember,
  days,
  note,
  process,
) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/balance/addorreduce", {
      flag: "addOrLessBalance",
      parameters: {
        idWorkspace: workspacId,
        idPolicy: idPolicy,
        idMembers: [
          {
            id: idMember,
          },
        ],
        leaveDays: days,
        note: note,
        process: process,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getrequestlistService = (sendData) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/TimeOffRequest/getrequestlist", {
      flag: "getrequestlist",
      parameters: {
        workspaceid: sendData.workspace_id,
        memberid: sendData.memberid,
        requeststatus: sendData.requeststatus,
        startdate: sendData.startdate,
        enddate: sendData.enddate,
        page: sendData.page,
        limit: sendData.limit,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getTimeoffRequestList = (payload) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/TimeOffRequest/getrequestlist", {
      flag: "getApprovalRequestlist",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const approveTimeoff = (payload) => {
  return axiosInstance
    .post(
      TIMEOFF_URL +
      "/TimeOffRequest/multiple/changestatus?flag=multipleChangeStatus",
      {
        parameters: payload,
      },
    )
    .then((response) => {
      return response.data;
    });
};

export const getCalendarTimesheetWeekService = (
  startDate,
  endDate,
  memberId,
  workspaceId,
) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/calendar/timesheet?flag=getCalendarTimesheet&startDate=${startDate}&endDate=${endDate}&memberId=${memberId}&workspaceId=${workspaceId}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const getCalendarTimesheetFilterService = (
  startDate,
  endDate,
  memberId,
  workspaceId,
  eventType,
  taskName,
  dailyBillAmount,
  workHrs,
) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/calendar/timesheet?flag=getCalendarTimesheet&startDate=${startDate}&endDate=${endDate}&memberId=${memberId}&workspaceId=${workspaceId}&eventType=${eventType}&taskName=${taskName}&dailyBillAmount=${dailyBillAmount}&workHours=${workHrs}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const getCalendarTimesheetDayService = (
  startDate,
  memberId,
  workspaceId,
) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/calendar/timesheet?flag=getCalendarTimesheetDay&startDate=${startDate}&memberId=${memberId}&workspaceId=${workspaceId}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const getassigneeslistService = (workspaceID, policyID, search) => {
  return axiosInstance
    .post(
      `${TIMEOFF_URL}/LeavePolicy/getassigneeslist?flag=getassigneeslist&workspaceid=${workspaceID}&id=${policyID}&search=${search}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getapproverslistService = (workspaceID, policyID, search) => {
  return axiosInstance
    .post(
      `${TIMEOFF_URL}/LeavePolicy/getapproverslist?flag=getapproverslist&workspaceid=${workspaceID}&id=${policyID}&search=${search}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const changestatusService = (statusChangeData) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/TimeOffRequest/changestatus?flag=changestatus", {
      parameters: {
        workspaceid: statusChangeData.workspaceid,
        memberid: statusChangeData.memberid,
        policyid: statusChangeData.policyid,
        startdate: statusChangeData.startdate,
        enddate: statusChangeData.enddate,
        timeperiod: statusChangeData.timeperiod,
        daycount: statusChangeData.daycount,
        hourCount: statusChangeData.hourCount,
        id: statusChangeData.id,
        requeststatus: statusChangeData.requeststatus,
        comments: statusChangeData.comments,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const createRequestTimeOffService = (createData) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/TimeOffRequest/add?flag=addNew", {
      parameters: {
        workspaceid: createData.workspaceid,
        memberid: "",
        policyid: createData.policyid,
        startdate: createData.startdate,
        enddate: createData.enddate,
        timeperiod: createData.timeperiod,
        daycount: createData.daycount,
        notes: createData.notes,
        startTime: createData.startTime,
        endTime: createData.endTime,
        hourCount: createData.hourCount,
        requestedDates: createData.requestedDates,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getPoliciesListService = (workspaceID) => {
  return axiosInstance
    .post(
      `${TIMEOFF_URL}/TimeOffRequest/getpolicieslist?flag=getpolicieslist&workspaceid=${workspaceID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getTimelineServices = (
  idWorkspace,
  fromDate,
  toDate,
  groupIds,
  memberIds,
) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/leave/timeline", {
      flag: "getTimeline",
      parameters: {
        idWorkspace: idWorkspace,
        fromDate: fromDate,
        toDate: toDate,
        memberIds: memberIds,
        groupIds: groupIds,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getTimelineExport = (timelinepayload) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/leave/timeline/export", {
      flag: "getTimelineExport",
      parameters: {
        idWorkspace: timelinepayload.idWorkspace,
        fromDate: timelinepayload.fromDate,
        toDate: timelinepayload.toDate,
        memberIds: timelinepayload.memberIds,
        groupIds: timelinepayload.groupIds,
        exportAs: timelinepayload.exportAs,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const resendVerificationMailService = (email) => {
  return axiosInstance
    .post(
      `${AUTH_URL}/resendverificationmail?username=${email}&flag=resendverificationmail`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getprojectlistService = (workspaceID, customerId) => {
  return axiosInstance
    .post(
      `${INVOICE_URL}/invoice/getprojectlist?flag=getProjectList&workspaceid=${workspaceID}&customerid=${customerId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const createCategoryServices = (idWorkspace, name, amount, unit) => {
  return axiosInstance
    .post(EXPENSE_URL + "/category/create", {
      flag: "createCategory",
      parameters: {
        idWorkspace: idWorkspace,
        name: name,
        amount: amount,
        unit: unit,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const fetchCategoryServices = (idWorkspace, status, page, limit) => {
  return axiosInstance
    .post(EXPENSE_URL + "/category/fetch?flag=fetchCategory", {
      flag: "fetchCategory",
      parameters: {
        idWorkspace: idWorkspace,
        status: status,
        page: page,
        limit: limit,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editCategoryServices = (
  idCategory,
  idWorkspace,
  name,
  amount,
  unit,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/category/edit", {
      flag: "editCategory",
      parameters: {
        id: idCategory,
        idWorkspace: idWorkspace,
        name: name,
        amount: amount,
        unit: unit,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateCategoryStatusServices = (
  idWorkspace,
  idCategory,
  status,
) => {
  return axiosInstance
    .patch(
      `${EXPENSE_URL}/category/status?flag=updateCategoryStatus&idWorkspace=${idWorkspace}&id=${idCategory}&status=${status}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const timeSheetDetailsServices = (
  id,
  description,
  billable,
  projectId,
  taskId,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/timesheet/updatedetails", {
      flag: "updatetimesheetdetails",
      parameters: {
        id: id,
        description: description,
        billable: billable,
        projectId: projectId,
        taskId: taskId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getMembersService = (workspaceID) => {
  return axiosInstance
    .get(
      `${EXPENSE_URL}/expense/getmembers?flag=getMembers&idWorkspace=${workspaceID}&search=`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getApproversServices = (workspaceID) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/getapprovers", {
      flag: "getApprovers",
      parameters: {
        idWorkspace: workspaceID,
      },
    })
    .then((response) => {
      return response?.data;
    });
};

export const assignApproversServices = (
  id,
  workspaceID,
  primaryapprover,
  secondaryapprover,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/assignapprovers", {
      flag: "assignApprovers",
      parameters: {
        id: id,
        idWorkspace: workspaceID,
        primaryapprover: primaryapprover,
        secondaryapprover: secondaryapprover,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getCategoryService = (workspaceID) => {
  return axiosInstance
    .get(
      `${EXPENSE_URL}/category/getall?flag=getAllCategory&idWorkspace=${workspaceID}&search=`,
    )
    .then((response) => {
      return response.data;
    });
};

export const createExpenseServices = (
  idWorkspace,
  idProject,
  idMember,
  idCategory,
  expenceDate,
  amount,
  note,
  billable,
  attachements,
  expenseCurrency,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/create", {
      flag: "createExpense",
      parameters: {
        idWorkspace: idWorkspace,
        idProject: idProject,
        idMember: idMember,
        idCategory: idCategory,
        expenceDate: expenceDate,
        amount: amount,
        note: note,
        billable: billable,
        attachements: attachements,
        expenseCurrency: expenseCurrency ? expenseCurrency : "",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getCommentHistoryService = (workspaceId, expenseId) => {
  return axiosInstance
    .get(
      `${EXPENSE_URL}/expense/comments?flag=getExpenseComments&idWorkspace=${workspaceId}&idExpense=${expenseId}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const getExpenseDashboardService = (payload) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/getDetailsForDashBoard", {
      flag: "getDetailsForDashBoard",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const fetchExpenseServices = (
  fetchFor,
  workspaceID,
  id,
  fromDate,
  toDate,
  status,
  page,
  posts,
  currencies,
  categories,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/fetch", {
      flag: "fetchExpense",
      parameters: {
        fetchFor: fetchFor,
        idWorkspace: workspaceID,
        memberIDs: id,
        fromDate: fromDate,
        toDate: toDate,
        statusFilter: status,
        page: page,
        limit: posts,
        currencies: currencies,
        categories: categories,
      },
    })
    .then((response) => {
      return response.data;
    });
};
export const fetchExpenseCurrencyServices = (fetchFor, workspaceID, status) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/fetch", {
      flag: "fetchExpenseCurrencies",
      parameters: {
        fetchFor: fetchFor,
        idWorkspace: workspaceID,
        status: status,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const MarkasImpurseServices = (markuspayload) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/markasreimburse", {
      flag: "markasreimburse",
      parameters: {
        expenseIDs: markuspayload.expenseIDs,
        idWorkspace: markuspayload.workspaceID,
        paidAttachments: markuspayload.paidAttachments,
        paymentMethod: markuspayload.paymentMethod,
        referenceNumber: markuspayload.referenceNumber,
        paymentDate: markuspayload.paymentDate,
        notes: markuspayload.notes,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editExpenseServices = (
  workspaceID,
  id,
  idProject,
  idMember,
  idCategory,
  expenceDate,
  amount,
  note,
  billable,
  attachements,
  expenseCurrency,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/edit", {
      flag: "editExpense",
      parameters: {
        id: id,
        idWorkspace: workspaceID,
        idProject: idProject,
        idMember: idMember,
        idCategory: idCategory,
        expenceDate: expenceDate,
        amount: amount,
        note: note,
        billable: billable,
        attachements: attachements,
        expenseCurrency: expenseCurrency,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteExpenseService = (idWorkspace, id) => {
  return axiosInstance
    .patch(
      `${EXPENSE_URL}/expense/status?flag=deleteExpense&idWorkspace=${idWorkspace}&id=${id}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const downloadExpensePdfService = (idWorkspace, idExpense) => {
  return axiosInstance
    .get(
      `${EXPENSE_URL}/expense/downloadpdf?flag=downloadExpensePdf&idWorkspace=${idWorkspace}&idExpense=${idExpense}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const archieveExpenseServices = (expenseId) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/retrieveexpense", {
      flag: "archieveexpense",
      parameters: {
        id: expenseId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const submitApprovalServices = (
  idWorkspace,
  idMember,
  fromDate,
  toDate,
  expenseIDs,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/submit", {
      flag: "submitForApproval",
      parameters: {
        idWorkspace: idWorkspace,
        memberIDs: idMember,
        expenseIDs: expenseIDs,
        fromDate: fromDate,
        toDate: toDate,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const changeExpenseServices = (expenseId, idWorkspace, action) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/changeexpensestatus", {
      flag: "changeexpensestatus",
      parameters: {
        id: expenseId,
        idWorkspace: idWorkspace,
        action: action,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const remindApproveServices = (
  idWorkspace,
  idMember,
  fromDate,
  toDate,
  expenseIds,
) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/remindforapprove", {
      flag: "remindToApprove",
      parameters: {
        idWorkspace: idWorkspace,
        idMember: idMember,
        expenseIds: expenseIds,
        fromDate: fromDate,
        toDate: toDate,
      },
    })
    .then((response) => {
      return response.data;
    });
};
export const getMemberApprovalTimesheetsDetails = (getMemberDetailsPayload) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/getTimesheetDetails", {
      flag: "getMemberApprovalTimesheets",
      parameters: {
        endDate: getMemberDetailsPayload.endDate,
        idMember: getMemberDetailsPayload.idMember,
        idWorkspace: getMemberDetailsPayload.idWorkspace,
        myApprovals: getMemberDetailsPayload.myApprovals,
        startDate: getMemberDetailsPayload.startDate,
        idProject: getMemberDetailsPayload.idProject,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const ApprovalListV2Services = (
  managerid,
  search,
  orderBy,
  sortBy,
  limit,
  page,
  workspaceid,
  projectIds,
  myApprovals,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/Get/MembersListForApproval", {
      flag: "MembersApprovalListV2",
      parameters: {
        managerid: managerid,
        search: search,
        orderBy: orderBy,
        sortBy: sortBy,
        limit: limit,
        page: page,
        workspaceid: workspaceid,
        projectIds: projectIds,
        myApprovals: myApprovals,
      },
    })
    .then((response) => {
      return response?.data;
    });
};

export const TimesheetDashboardApprovalList = (
  managerid,
  search,
  orderBy,
  sortBy,
  limit,
  page,
  workspaceid,
  projectIds,
  myApprovals,
  fetchType,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/Get/MembersListForApproval", {
      flag: "MembersApprovalListV2",
      parameters: {
        managerid: managerid,
        search: search,
        orderBy: orderBy,
        sortBy: sortBy,
        limit: limit,
        page: page,
        workspaceid: workspaceid,
        projectIds: projectIds,
        myApprovals: myApprovals,
        fetchType: fetchType,
      },
    })
    .then((response) => {
      return response?.data;
    });
};

export const MemberExpenseApprovalServices = (
  fetchFor,
  workspaceid,
  memberIDs,
  page,
  limit,
  myApprovals,
  fromDate,
  toDate,
  approvers,
  categories,
  projects,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/expense", {
      flag: "ExpenseApproval",
      parameters: {
        fetchFor: fetchFor,
        workspaceid: workspaceid,
        page: page,
        limit: limit,
        myApprovals: myApprovals,
        fromDate: fromDate,
        toDate: toDate,
        memberIDs: memberIDs,
        approvers: approvers,
        categories: categories,
        projects: projects,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getApproverListService = (workspaceId) => {
  return axiosInstance
    .get(
      MEMBER_URL +
      `/member/get-expense-approvers?flag=getExpenseApprovers&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const approveAllServices = (idWorkspace, idMember, fromDate, toDate) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/approveall", {
      flag: "approveAll",
      parameters: {
        idWorkspace: idWorkspace,
        idMember: idMember,
        fromDate: fromDate,
        toDate: toDate,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const retrieveExpenseServices = (expenseId) => {
  return axiosInstance
    .post(EXPENSE_URL + "/expense/retrieveexpense", {
      flag: "retrieveexpense",
      parameters: {
        id: expenseId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

//Schedule Meeting APIs
export const scheduleMeetingServices = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective/meeting", {
      flag: "objectiveMeeting",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getScheduleMeetingServices = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/getall/meeting`, {
      flag: "getObjectiveMeeting",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getIndividualMeetingService = (meetingId) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/get/meeting?flag=getObjectiveMeetingById&meetingId=${meetingId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateScheduleMeetingServices = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/meeting`, {
      flag: "objectiveMeeting",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteScheduleMeetingServices = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/meeting`, {
      flag: "objectiveMeeting",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};
//End of Schedule Meeting APIs

export const workspaceOwnersService = (workspaceID, objectiveId, meetingId) => {
  return axiosInstance
    .post(OKR_URL + "/objective/getWorkspaceOwners", {
      flag: "getWorkspaceOwners",
      parameters: {
        idWorkspace: workspaceID,
        objectiveId,
        meetingId,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const workspaceOwnersContractorService = (workspaceID, memberID) => {
  return axiosInstance
    .get(
      MEMBER_URL +
      `/member/workspaces/get?flag=getContractorAccessMembers&workspaceId=${workspaceID}&memberId=${memberID}&search=`,
      {},
    )
    .then((response) => {
      return response.data;
    });
};

export const getWorkspaceRegularEmployeesService = (workspaceId) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/workspace/members/regular?flag=getWorkspaceRegularEmployees&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getMemberCustomWorkingDaysService = (
  workspaceId,
  search,
  page,
  limit,
) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/workspace/members/custom-working-days?flag=getMemberCustomWorkingDays&workspaceId=${workspaceId}&search=${search}&page=${page}&limit=${limit}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const editMemberCustomWorkingDaysService = (
  workspaceId,
  memberId,
  customWorkingDays,
) => {
  return axiosInstance
    .patch(
      `${ADMIN_URL}/workspace/members/custom-working-days?flag=editMemberCustomWorkingDays`,
      {
        flag: "editMemberCustomWorkingDays",
        parameters: { workspaceId, memberId, customWorkingDays },
      },
    )
    .then((response) => {
      return response.data;
    });
};

export const addMemberCustomWorkingDaysService = (
  workspaceId,
  memberIds,
  customWorkingDays,
) => {
  return axiosInstance
    .post(
      `${ADMIN_URL}/workspace/members/custom-working-days?flag=addMemberCustomWorkingDays`,
      {
        flag: "addMemberCustomWorkingDays",
        parameters: { workspaceId, memberIds, customWorkingDays },
      },
    )
    .then((response) => {
      return response.data;
    });
};

export const removeMemberCustomWorkingDaysService = (workspaceId, memberId) => {
  return axiosInstance
    .delete(`${ADMIN_URL}/workspace/members/custom-working-days`, {
      data: {
        flag: "removeMemberCustomWorkingDays",
        parameters: { workspaceId, memberId },
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const mentionMembersService = (workspaceID, objectiveId, flag) => {
  let tempParams = flag
    ? { idWorkspace: workspaceID, objectiveId: objectiveId }
    : { idWorkspace: workspaceID, keyresultId: objectiveId };
  return axiosInstance
    .post(OKR_URL + "/objective/getWorkspaceOwners", {
      flag: "getObjectiveMentionMembers",
      parameters: tempParams,
    })
    .then((response) => {
      return response.data;
    });
};

export const getObjectivesService = (createSessionId, idObjective) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/workspaceObjectives?flag=getWorkspaceObjectives&sessionId=${createSessionId}&notInObjectiveId=${idObjective}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getChildObjectivesService = (idObjective, idSession) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective?flag=getObjectiveRelativeProgress&idObjective=${idObjective}&idSession=${idSession}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getObjectivesAlignmentService = (idObjective, idSession) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective?flag=getMyOKRAllignment&idObjective=${idObjective}&idSession=${idSession}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const objetiveTreeViewalignmentFilterService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/allignment`, {
      flag: "getMyOKRAllignment",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const createKeyResultService = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session/result", {
      flag: "createSessionKeyResult",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getKeyResultService = (id) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/session/result?flag=getSessionKeyResult&idObjectiveKeyResult=${id}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateKeyResultPopupService = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective/keyresult/update", {
      flag: "updateKeyResult",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const saveObjectiveTemplateService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/template`, {
      flag: "objectiveTemplate",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getObjectiveTemplateService = (workspaceID) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/get/template?flag=getObjectiveTemplate&workspaceId=${workspaceID}&responseType=dropDown&templateId&search
  `,
    )
    .then((response) => {
      return response.data;
    });
};

export const deleteObjectiveTemplateService = (templateId) => {
  return axiosInstance
    .delete(
      `${OKR_URL}/objective/delete/template?flag=deleteObjectiveTemplate&objectiveTemplateId=${templateId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const editKeyResultService = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session/result/edit", {
      flag: "editSessionKeyResult",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const editKeyResultTitleService = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective/keyresult/editTitle", {
      flag: "editKeyResultTitle",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const objectivesProjectListService = (workspaceID) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/project/list?flag=getProjectList&workspaceId=${workspaceID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const objectivesTaskListService = (objProjectId) => {
  return axiosInstance
    .get(
      `${OKR_URL}/objective/project/task?flag=getProjectTaskList&projectId=${objProjectId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const objectiveTaskLinkService = (
  objectiveId,
  projectTaskId,
  description,
) => {
  return axiosInstance
    .post(OKR_URL + "/objective/task/link", {
      flag: "objectiveTaskLink",
      parameters: {
        objectiveId: objectiveId,
        projectTaskId: projectTaskId,
        description: description,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteKeyResultService = (idKeyResult) => {
  return axiosInstance
    .post(OKR_URL + "/keyResult/delete", {
      flag: "deleteKeyResult",
      parameters: {
        keyResultId: idKeyResult,
        status: false,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const objectiveLinkedService = (objectiveId, linkedObjectiveId) => {
  return axiosInstance
    .post(OKR_URL + "/objective/relatedItems", {
      flag: "objectiveRelatedItems",
      parameters: {
        objectiveId: objectiveId,
        relatedObjectiveId: linkedObjectiveId,
        status: true,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteObjectiveTaskService = (deleteTaskId) => {
  return axiosInstance
    .post(OKR_URL + "/objective/task/delete", {
      flag: "deleteObjectiveTask",
      parameters: {
        objectiveTaskId: deleteTaskId,
        status: false,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const ObjectiveTaskStatusService = (objectiveTaskId, status) => {
  return axiosInstance
    .post(OKR_URL + "/task/updateStatus", {
      flag: "updateObjectiveTaskStatus",
      parameters: {
        objectiveTaskId: objectiveTaskId,
        status: status,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editObjectiveService = (
  idObjective,
  idWorkspace,
  idSession,
  title,
  idLinkObjective,
  visibility,
  description,
  tagIds,
  ownerIds,
  idDepartment,
  followerIds,
) => {
  return axiosInstance
    .post(OKR_URL + "/objective/edit", {
      flag: "editObjective",
      parameters: {
        idObjective: idObjective,
        idWorkspace: idWorkspace,
        idSession: idSession,
        title: title,
        idLinkObjective: idLinkObjective,
        visibility: visibility,
        description: description,
        tagIds: tagIds,
        ownerIds: ownerIds,
        idDepartment: idDepartment,
        followerIds: followerIds,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const updateObjectiveStatusService = (objectiveId, status, comments) => {
  return axiosInstance
    .post(OKR_URL + "/objective/updateStatus", {
      flag: "updateObjectiveStatus",
      parameters: {
        objectiveId: objectiveId,
        status: status,
        comments: comments,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const bulkUploadService = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective/upload", {
      flag: "objectivesUpload",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteObjectiveService = (getIdObjective) => {
  return axiosInstance
    .post(OKR_URL + "/objective/delete", {
      flag: "deleteObjective",
      parameters: {
        objectiveId: getIdObjective,
        status: false,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getSessionDashboardService = (
  idWorkspace,
  startDate,
  endDate,
  limit,
  pageNo,
  status,
  sortedBy,
  orderBy,
  objectiveFiltersDTO,
  privacy,
  departmentIds,
) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session/dashboard", {
      flag: "getSessionDashboard",
      parameters: {
        idWorkspace: idWorkspace,
        startDate: startDate,
        endDate: endDate,
        limit: limit,
        pageNo: pageNo,
        status: status,
        sortedBy,
        orderBy,
        objectiveFiltersDTO,
        privacy,
        departmentIds,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const deleteLinkedObjectiveService = (linkedObjectiveId) => {
  return axiosInstance
    .post(OKR_URL + "/objective/updateObjectiveRelatedItemStatus", {
      flag: "updateObjectiveRelatedItemStatus",
      parameters: {
        objectiveLinkedId: linkedObjectiveId,
        status: false,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const linkaccessabilityService = (memberId, uniqueid) => {
  return axiosInstance
    .post(
      `${AUTH_URL}/checklinkaccessability?memberId=${memberId}&uniqueid=${uniqueid}&flag=checklinkaccessability`,
    )
    .then((response) => {
      return response.data;
    });
};

export const cloneObjectiveService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/clone`, {
      flag: "cloneObjective",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const cloneKeyResultService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/session/result/clone`, {
      flag: "cloneKeyResult",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getAreaGraphService = (workspaceID) => {
  return axiosInstance
    .get(
      `${OKR_URL}/session/graphResult?flag=getSessionDashboardGraph&workspaceId=${workspaceID}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getStatisticDataService = (payload, flag) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/session/statistics`, {
      flag: flag,
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};
// invoice edit logo, background and signature
export const updateImageService = (
  invoiceId,
  base64encode,
  flowtype,
  imagetype,
) => {
  return axiosInstance
    .post(INVOICE_URL + "/invoice/updategraphics", {
      flag: "updategraphics",
      parameters: {
        id: invoiceId,
        url: base64encode,
        flowtype: flowtype,
        fileName: imagetype,
      },
    })
    .then((response) => {
      return response.data;
    });
};

/*==========Nudges get method code start here==========*/
export const getNudgesService = (
  workspaceId,
  page,
  posts,
  value,
  schedulerName,
) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/getall", {
      flag: "GetNudges",
      parameters: {
        workspaceId: workspaceId,
        activenudgesPage: page,
        activenudgesLimit: posts,
        recommendnudgesPage: 1,
        recommendnudgesLimit: 5,
        search: value,
        schedulerName: schedulerName,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges get method code end here==========*/

/*==========Nudges delete method code start here==========*/
export const deleteNudgesService = (
  workspaceId,
  id,
  flowtype,
  schedulerName,
) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/editv2", {
      flag: "EditNudgesV2",
      parameters: {
        workspaceId: workspaceId,
        id: id,
        flowtype: "Delete",
        schedulerName: schedulerName,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges delete method code end here==========*/

/*==========Nudges search method code start here==========*/
export const searchNudgesService = (workspaceId, page, posts, value) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/getall", {
      flag: "GetNudges",
      parameters: {
        workspaceId: workspaceId,
        activenudgesPage: page,
        activenudgesLimit: posts,
        recommendnudgesPage: 1,
        recommendnudgesLimit: 5,
        search: value,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges search method code end here==========*/

/*==========Nudges create method dropdown code start here==========*/
export const dropdownCreateNudgesService = (dropDownsNudges) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/getdropdownoptions", {
      flag: "GetDropdownValues",
      parameters: {
        workspaceId: dropDownsNudges.workspaceId,
        moduleId: dropDownsNudges.moduleId,
        eventId: dropDownsNudges.eventId,
        optionName: dropDownsNudges.optionName,
        searchKey: dropDownsNudges.searchKey,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges create method dropdown code end here==========*/

/*==========Nudges create method code start here==========*/
export const createNudgesService = (payloadCreateNudges) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/create", {
      flag: "CreateNudge",

      parameters: {
        workspaceId: payloadCreateNudges.payloadCreateNudges.workspaceId,
        moduleEventMappingId:
          payloadCreateNudges.payloadCreateNudges.moduleEventMappingId,
        nudgeName: payloadCreateNudges.payloadCreateNudges.nudgeName,
        stepName: payloadCreateNudges.payloadCreateNudges.stepName,
        flowtype: "Create",
        nudgeStatus: payloadCreateNudges.payloadCreateNudges.nudgeStatus,
        parentNudgeId: payloadCreateNudges.payloadCreateNudges.parentNudgeId,
        moduleId: payloadCreateNudges.payloadCreateNudges.moduleId,
        actionReqList: payloadCreateNudges.payloadCreateNudges.actionReqList,
        forEveryone: payloadCreateNudges.payloadCreateNudges.everyOneCheckbox,
        triggerSetup: [
          {
            eventParameterId:
              payloadCreateNudges.payloadCreateNudges.eventParameterId,
            paramValue: payloadCreateNudges.payloadCreateNudges.paramValue,
            parameterType:
              payloadCreateNudges.payloadCreateNudges.parameterType,
          },
        ],

        //new code for scheduleOption
        scheduleOption: payloadCreateNudges.payloadCreateNudges.scheduleOption,
        scheduledDays: payloadCreateNudges.payloadCreateNudges.scheduledDays,
        dateType: payloadCreateNudges.payloadCreateNudges.dateType,
        intervalType: payloadCreateNudges.payloadCreateNudges.intervalType,
        intervals: payloadCreateNudges.payloadCreateNudges.intervals,
        timeZone: payloadCreateNudges.payloadCreateNudges.timeZone,
        scheduledOn: payloadCreateNudges.payloadCreateNudges.scheduledOn,
        scheduledAt: payloadCreateNudges.payloadCreateNudges.scheduledAt,
        showAsNudge: payloadCreateNudges.payloadCreateNudges.showAsNudge,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges create method code end here==========*/

/*==========Recommend create method code start here==========*/
export const createNudgesRecommendService = (
  workspaceId,
  moduleEventMappingId,
  nudgeName,
  stepName,
  eventParameterId,
  paramValue,
  parameterType,
  actionReqList,
  nudgeStatus,
  parentNudgeId,
  moduleId,
  scheduleOption,
  scheduledDays,
  dateType,
  intervalType,
  intervals,
  timeZone,
  scheduledOn,
  scheduledAt,
  showAsNudge,
  schedulerName,
) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/create", {
      flag: "CreateNudge",
      parameters: {
        workspaceId,
        moduleEventMappingId,
        nudgeName,
        stepName,
        flowtype: "Create",

        triggerSetup: [
          {
            eventParameterId,
            paramValue,
            parameterType,
          },
        ],

        actionReqList: actionReqList.map((item) => ({
          ...item,
          nudgeStatus,
        })),

        parentNudgeId,
        moduleId,
        scheduleOption,
        scheduledDays,
        dateType,
        intervalType,
        intervals,
        timeZone,
        scheduledOn,
        scheduledAt,
        showAsNudge,
        schedulerName,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Recommend create method code end here==========*/

/*==========Nudges EditGet method code start here==========*/
export const editGetNudgesService = (workspaceId, id) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/getbyid", {
      flag: "GetNudgeDetails",
      parameters: {
        workspaceId: workspaceId,
        id: id,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges EditGet method code end here==========*/

/*==========Nudges Edit method code start here==========*/
export const editNudgesService = (payloadEditNudges) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/edit", {
      flag: "EditNudges",
      parameters: {
        id: payloadEditNudges.payloadEditNudges.id,
        nudgeId: payloadEditNudges.payloadEditNudges.nudgeId,
        workspaceId: payloadEditNudges.payloadEditNudges.workspaceId,
        moduleEventMappingId:
          payloadEditNudges.payloadEditNudges.moduleEventMappingId,
        nudgeName: payloadEditNudges.payloadEditNudges.nudgeName,
        stepName: payloadEditNudges.payloadEditNudges.stepName,
        flowtype: "Edit",
        nudgeStatus: payloadEditNudges.payloadEditNudges.nudgeStatus,
        parentNudgeId: payloadEditNudges.payloadEditNudges.parentNudgeId,
        moduleId: payloadEditNudges.payloadEditNudges.moduleId,
        actionReqList: payloadEditNudges.payloadEditNudges.actionReqList,
        triggerSetup: [
          {
            id: payloadEditNudges.payloadEditNudges.triggerSetupId,
            eventParameterId:
              payloadEditNudges.payloadEditNudges.eventParameterId,
            paramValue: payloadEditNudges.payloadEditNudges.paramValue,
            parameterType: payloadEditNudges.payloadEditNudges.parameterType,
          },
        ],
        //new code for scheduleOption
        scheduleOption: payloadEditNudges.payloadEditNudges.scheduleOption,
        scheduledDays: payloadEditNudges.payloadEditNudges.scheduledDays,
        dateType: payloadEditNudges.payloadEditNudges.dateType,
        intervalType: payloadEditNudges.payloadEditNudges.intervalType,
        intervals: payloadEditNudges.payloadEditNudges.intervals,
        timeZone: payloadEditNudges.payloadEditNudges.timeZone,
        scheduledOn: payloadEditNudges.payloadEditNudges.scheduledOn,
        scheduledAt: payloadEditNudges.payloadEditNudges.scheduledAt,
        showAsNudge: payloadEditNudges.payloadEditNudges.showAsNudge,
        schedulerName: payloadEditNudges.payloadEditNudges.schedulerName,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges Edit method code end here==========*/

/*==========Nudges status change  code start here==========*/
export const statusChangeNudgesService = (
  workspaceId,
  id,
  nudgeName,
  nudgeStatus,
  flowtype,
) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/editv2", {
      flag: "EditNudgesV2",
      parameters: {
        workspaceId: workspaceId,
        id: id,
        nudgeName: nudgeName,
        nudgeStatus: nudgeStatus,
        flowtype: flowtype,
      },
    })
    .then((response) => {
      return response.data;
    });
};

/*==========Nudges status change method code end here==========*/

/*==========Nudges Timezone method dropdown code start here==========*/
export const dropdownCreateNudgesServicesss = (dropDownsNudges) => {
  return axiosInstance
    .post(NUDGES_URL + "/nudge/getdropdownoptions", {
      flag: "GetDropdownValues",
      parameters: {
        workspaceId: dropDownsNudges.workspaceId,
        moduleId: dropDownsNudges.moduleId,
        eventId: dropDownsNudges.eventId,
        optionName: dropDownsNudges.optionName,
        searchKey: dropDownsNudges.searchKey,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const timeZoneCreateNudgesServices = (searchValue) => {
  return axiosInstance
    .post(
      `${NUDGES_URL}/nudge/getTimeZoneList?flag=GetTimeZoneList&search=${searchValue}`,
    )
    .then((response) => {
      return response.data;
    });
};
export const customerSupportService = (
  name,
  email,
  description,
  attachments,
  countryCode,
  mobilenumber,
) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/sendMailToNotifyIssue", {
      flag: "sendIssueReportEmail",
      parameters: {
        name,
        email,
        description,
        attachments,
        countryCode,
        mobilenumber,
      },
    })
    .then((response) => {
      return response.data;
    });
};
/*==========Nudges create method dropdown code end here==========*/

// file uploade create url
export const getFileUrl = (data, onSuccess, onError) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${NUDGES_URL}/getpresignedurl`,
        data,
      );
      const result = response.data;

      if (onSuccess) {
        await onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getWorkspaceMembers = (workspaceID, groupId, search) => {
  return axiosInstance
    .post(ADMIN_URL + "/workspace/members/list", {
      flag: "getWorkspaceMembers",
      parameters: {
        idWorkspace: workspaceID,
        idGroup: groupId,
        search: search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editTaskTemplate = (data, onSuccess, onError) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${PROJECT_URL}/project/task/edit/template`,
        data,
      );
      const result = response.data;

      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getSuperAdminOrganisation = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${SUPERADMIN_URL}/organization/search`,
        {
          flag: "searchWorkspace",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getSuperAdminCustomerWorkspacesService = (ownerId) => {
  return axiosInstance
    .get(
      `${SUPERADMIN_URL}/customer/workspace?flag=GET_CUSTOMER_WORKSPACES&ownerId=${ownerId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const updateSuperAdminPlanService = (payload) => {
  return axiosInstance
    .post(STRIPE_URL_ONE + "/v2/plan/update-plan", payload)
    .then((response) => {
      return response.data;
    });
};
export const retrievePlanService = (payload) => {
  return axiosInstance
    .get(STRIPE_URL_ONE + "/v2/plan/retrieve-plan", {
      flag: "retrievePlan",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
export const retrievePlanPricingService = (planId) => {
  return axiosInstance
    .get(`${STRIPE_URL_ONE}/v2/plan/retrieve-plan-pricing?planId=${planId}`)
    .then((response) => {
      return response.data;
    });
};

export const createPlanPriceService = (payload) => {
  return axiosInstance
    .post(STRIPE_URL_ONE + "/v2/plan/manage-plan-pricing", payload)
    .then((res) => {
      return res.data;
    });
};

export const updatePlanPriceService = (payload) => {
  return axiosInstance
    .post(STRIPE_URL_ONE + "/v2/plan/manage-plan-pricing", payload)
    .then((res) => {
      return res.data;
    });
};

export const deletePlanPriceService = (planId, priceId) => {
  return axiosInstance
    .delete(
      `${STRIPE_URL_ONE}/v2/plan/delete-plan-pricing?planId=${planId}&priceId=${priceId}`,
    )
    .then((res) => {
      return res.data;
    });
};
export const updateCustomerSubscriptionService = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${STRIPE_URL_ONE}/v2/plan/update-customer-subscription`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Update subscription error:", error);
    throw error;
  }
};

export const getSuperAdminPlansService = () => {
  return axiosInstance
    .get(SUPERADMIN_PRICING_URL + "/retrieve")
    .then((response) => {
      return response.data;
    });
};

export const getSuperAdminCustomersService = (payload) => {
  return axiosInstance
    .post(SUPERADMIN_URL + "/customer", {
      flag: "VIEW_CUSTOMER_AS_ORGANIZATION",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const superAdminChangePricingHistoryService = (
  planId,
  page = 0,
  size = 5,
) => {
  return axiosInstance
    .get(
      `${STRIPE_URL_ONE}/v2/plan/features/log?planId=${planId}&page=${page}&size=${size}`,
    )
    .then((response) => response.data);
};

export const superAdminPricingUpdateService = (pricingUpdate) => {
  return axiosInstance.put(
    STRIPE_URL_ONE + "/v2/plan/update-module-features",
    pricingUpdate,
  );
};

export const getOrganisationLogs = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(
        `${SUPERADMIN_URL}/getConfigLogDetails?flag=getconfigurationLogs&workspaceId=${data.workspaceId}&page=${data.page}&size=${data.size}`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};
export const getListOfModules = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(
        `${SUPERADMIN_URL}/getModulesList?workspaceId=${data}&flag=getModules`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const addNewOrganization = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${SUPERADMIN_URL}/organization/add?flag=addOrganization`,
        { flag: "addOrganization", parameters: data },
      );

      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const updateModuleStatus = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${SUPERADMIN_URL}/configureModules`,
        { flag: "configureModules", parameters: data },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const updateOrganizationStatus = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.patch(
        `${SUPERADMIN_URL}/updateWorkspaceStatus?flag=updateWorkspaceStatus&workspaceActive=${data.status}&updateStatusBy=owner&appOwnerId=${data.appOwnerId}`,
        {
          flag: "updateWorkspaceStatus",
          workspaceActive: `${data.status}`,
          updateStatusBy: "owner",
          appOwnerId: `${data.appOwnerId}`,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const viewOrganization = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${SUPERADMIN_URL}/workspace/memberDetails`,
        { flag: "viewWorkspace", parameters: data },
      );
      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const sentInvite = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${SUPERADMIN_URL}/member/reinvite`,
        { flag: "reinvitemember", parameters: data },
      );
      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (err) {
      if (onError) {
        onError(err);
      }
    }
  };
};

export const calenderSyncMsActionService = ({
  workspaceId,
  code,
  verifier,
  name,
}) => {
  let payload = {
    workspaceId: workspaceId,
    serviceOAuthCode: code,
    codeVerifier: verifier,
    serviceName: name,
  };
  if (process.env.REACT_APP_ENVIROMENT_FLAG === "local") {
    payload.requestedFrom = "local";
  }
  return axiosInstance
    .post(MEMBER_URL + "/member/syncCalendar", {
      flag: "syncCalendar",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const calenderSyncGoogleActionService = (workspaceId, code, name) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/syncCalendar", {
      flag: "syncCalendar",
      parameters: {
        workspaceId: workspaceId,
        serviceOAuthCode: code,
        serviceName: name,
        requestedFrom: "web",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

export const triggerCalenderDefaultActionService = (name) => {
  return axiosInstance
    .patch(
      `${MEMBER_URL}/member/setAsPrimaryService?flag=setAsPrimary&primaryService=${name}`,
    )
    .then((response) => {
      return response.data;
    });
};
/*==========Handbook get method code start here==========*/

export const getHandbookService = (handbookdata) => {
  return axiosInstance
    .post(HANDBOOK_URL + "/fetch", {
      flag: "fetch_handbook",
      parameters: handbookdata,
    })
    .then((response) => {
      return response.data;
    });
};

export const postHandbookService = (handbookpostdata) => {
  return axiosInstance
    .post(HANDBOOK_URL + "/create", {
      flag: "create_handbook",
      parameters: handbookpostdata,
    })
    .then((res) => {
      return res.data;
    });
};
export const updateHandbookService = (handbookpostdata) => {
  return axiosInstance
    .put(HANDBOOK_URL + "/edit", {
      flag: "edit_handbook",
      parameters: handbookpostdata,
    })
    .then((res) => {
      return res.data;
    });
};

export const deleteHandbookService = (id, idWorkspace) => {
  return axiosInstance
    .patch(
      `${HANDBOOK_URL}/delete?flag=delete_handbook&id=${id}&idWorkspace=${idWorkspace}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const pricingCreateService = (pricingdetails) => {
  return axiosInstance.post(
    STRIPE_URL_ONE + "/subscription/update",
    pricingdetails,
  );
};

export const defaultPricingGetService = (memberId) => {
  return axiosInstance.get(
    STRIPE_URL_ONE + `/payment-method/default-method?memberId=${memberId}`,
  );
};

export const pricingGetService = (workspaceId) => {
  return axiosInstance.get(
    STRIPE_URL +
    `/subscription/retrieve-by-workspace?workspaceId=${workspaceId}`,
  );
};
export const pricingDashboardGetService = (pricingPostPayload) => {
  return axiosInstance.get(
    STRIPE_URL_ONE +
    `/billing?memberId=${pricingPostPayload.memberId}&page=${pricingPostPayload.page}&size=${pricingPostPayload.size}`,
  );
};
export const pricingDashboardCancelService = (pricingCacelPayload) => {
  return axiosInstance.post(
    STRIPE_URL_ONE + "/subscription/cancel",
    pricingCacelPayload,
  );
};

export const pricingAddCardDetailsService = (pricingAddCardPayload) => {
  return axiosInstance.post(
    STRIPE_URL_ONE + "/manage-billing-details/new-session",
    pricingAddCardPayload,
  );
};

export const cultureCategoryFetchService = (fetchDetails, languageCode) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/category/fetch/subCategory", {
      flag: "fetchSurveyCategorySubcategory",
      parameters: fetchDetails,
      languageCode: languageCode,
    })

    .then((res) => {
      return res.data;
    });
};

export const cultureSurveyCreateService = (createSurvey, languageCode) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey", {
      flag: "createSurvey",
      parameters: createSurvey,
      languageCode: languageCode,
    })
    .then((res) => {
      return res.data;
    });
};

export const cultureOKRTemplateNewService = (culturetempayload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/templates/strategy-templates", {
      flag: "fetchConversationByCategory",
      parameters: culturetempayload,
    })
    .then((res) => {
      return res.data;
    });
};

export const cultureFetchAdvanceCategory = (
  fetchAdvanceSurvey,
  languageCode,
) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/advanced/category", {
      flag: "fetchSurveyAdvanceCategory",
      parameters: fetchAdvanceSurvey,
      languageCode: languageCode,
    })
    .then((res) => {
      return res.data;
    });
};

export const cultureSurveyDeleteService = (deleteSurvey) => {
  return axiosInstance
    .put(CULTURALFIT + "/survey/delete", {
      flag: "deleteSurvey",
      parameters: deleteSurvey,
    })
    .then((response) => {
      return response.data;
    });
};

export const cultureChooseListService = (chooseSurvey) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/inputs", {
      flag: "getAllInputTypes",
      parameters: chooseSurvey,
    })
    .then((res) => {
      return res.data;
    });
};
export const cultrureQuestPostService = (postSurvey) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey", {
      flag: "createSurvey",
      parameters: postSurvey,
    })
    .then((res) => {
      return res.data;
    });
};
export const cultrureQuestConfigurationService = (QustionSurvey) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/question", {
      flag: "configureQuestion",
      parameters: QustionSurvey,
    })
    .then((res) => {
      return res.data;
    });
};
export const cultrureQuestConfigurationUpdateService = (
  QustionUpdateSurvey,
) => {
  return axiosInstance
    .put(CULTURALFIT + "/survey/question/update", {
      flag: "updateSurveyAndQuestion",
      parameters: QustionUpdateSurvey,
    })
    .then((res) => {
      return res.data;
    });
};
export const cultrureQuestConfigurationPreBuiltService = (
  QustionPreBuiltData,
) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/templates/add-survey-from-template", {
      flag: "createSurveyFromTemplate",
      parameters: QustionPreBuiltData,
    })
    .then((res) => {
      return res.data;
    });
};

export const cultrureQuestConfigurationGetService = (QustionGetSurvey) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/getById", {
      flag: "findSurveyById",
      parameters: QustionGetSurvey,
    })
    .then((res) => {
      return res.data;
    });
};

export const culturePublishSurveyAssigneeService = (surveyAssignees) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/publish", {
      flag: "publishSurvey",
      parameters: surveyAssignees,
    })
    .then((res) => {
      return res.data;
    });
};
export const culturePreBuiltTemplatesGetService = (templatePayload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/templates/get-all", {
      flag: "fetchAllSurveyTemplates",
      parameters: templatePayload,
    })
    .then((res) => {
      return res.data;
    });
};
export const culturePreBuiltTemplatesEditService = (templateEditPayload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/templates/get-by-id", {
      flag: "fetchSurveyTemplateById",
      parameters: templateEditPayload,
    })
    .then((res) => {
      return res.data;
    });
};
export const cultureUserPublishSurveyService = (surveyPublish) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/post/answer", {
      flag: "submitSurvey",
      parameters: surveyPublish,
    })
    .then((res) => {
      return res.data;
    });
};

// CIF - Get category list
export const getCultureCategoryListService = (getList) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/category/fetch", {
      flag: "fetchSurveyCategory",
      parameters: getList,
    })
    .then((res) => {
      return res.data;
    });
};
// CIF - Create category list
export const cultureCategoryCreateService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/category", {
      flag: "createSurveyCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
// CIF - Edit category list
export const cultureCategoryEditService = (payload) => {
  return axiosInstance
    .put(CULTURALFIT + "/survey/category", {
      flag: "updateSurveyCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
// CIF - Delete category list
export const cultureCategoryDeleteService = (payload) => {
  return axiosInstance
    .put(CULTURALFIT + "/survey/category/delete", {
      flag: "deleteSurveyCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
export const socialLoginService = (
  code,
  verifier,
  name,
  inviteType,
  workspaceId,
  token,
  priceLookupKey,
) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "oauth",
      parameters: {
        workspaceId: workspaceId,
        priceLookupKey: priceLookupKey,
        inviteType: inviteType,
        isOauthLogin: "yes",
        inviteToken: token,
        oAuthRequest: {
          serviceProvider: name,
          oauthServiceCode: code,
          codeVerifier: verifier,
          devicePlatform: "web",
        },
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getUserDynamicFieldsService = (id, userid) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "getDynamicFields",
      parameters: {
        workspaceId: id,
        memberId: userid,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const saveUserDynamicFieldsService = ({ dynamicfields }) => {
  return axiosInstance
    .post(AUTH_URL, {
      flag: "saveDynamicFields",
      parameters: {
        dynamicfields: [...dynamicfields],
      },
    })
    .then((response) => {
      return response.data;
    });
};

// CIF - Create sub-category list
export const cultureSubCategoryCreateService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/subcategory", {
      flag: "createSurveySubCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
// CIF - Edit sub-category list
export const cultureSubCategoryEditService = (payload) => {
  return axiosInstance
    .put(CULTURALFIT + "/survey/subcategory", {
      flag: "updateSurveySubCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
// CIF - Delete sub-category list
export const cultureSubCategoryDeleteService = (payload) => {
  return axiosInstance
    .put(CULTURALFIT + "/survey/subcategory/delete", {
      flag: "deleteSurveySubCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

//CIF - search catgeory & sub-category list
export const searchCategorySubCategoryFetchService = (fetchDetails) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/category/fetch/subCategory", {
      flag: "fetchSurveyCategorySubcategory",
      parameters: fetchDetails,
    })
    .then((res) => {
      return res.data;
    });
};

//CIF - User culture align list
export const userCultureAlignListFetchService = (fetchDetails) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/fetch/submit", {
      flag: "fetchSubmitSurvey",
      parameters: fetchDetails,
    })
    .then((res) => {
      return res.data;
    });
};
//CIF - User get survey by id
export const userGetSurveyByIdService = (fetchDetails) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/getById", {
      flag: "findSurveyById",
      parameters: fetchDetails,
    })
    .then((res) => {
      return res.data;
    });
};

export const getCultureCategoryDropdownListService = (
  getList,
  languageCode,
) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/category/getAll", {
      flag: "getSurveyCategory",
      parameters: getList,
      languageCode: languageCode,
    })
    .then((res) => {
      return res.data;
    });
};

export const getCultureSubCategoryListService = (payload, languageCode) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/subcategory/getAll", {
      flag: "getSurveySubCategory",
      parameters: payload,
      languageCode: languageCode,
    })
    .then((res) => {
      return res.data;
    });
};

export const getreportSurveyList = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/dropdown/getSurveyAssigneesById", {
      flag: "getSurveyAssigneesBySurveyId",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

// CIF - Get Culture Align Report list
export const getCultureAlignReportListService = (getList) => {
  return axiosInstance
    .post(REPORT_URL + "/getCifSurveyBySearch", {
      flag: "getCfiSurveyBySearch",
      parameters: getList,
    })
    .then((res) => {
      return res.data;
    });
};

export const getSurveyBySurveyIdList = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/getSurveyById", {
      flag: "getSurveyBySurveyId",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
export const getSurveyGraphDetailsService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/fetch/single/graph/cif", {
      flag: "fetchDataForCifSingleGraph",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const cifBasicConversationSelected = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/cif/basic", {
      flag: "advancedConversationReportWithApproval",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
export const cifBasicConversationSelectedFilter = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/cif/basic", {
      flag: "BasicConversationReportWithApproval",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const cifBasicConversationWithoutApproval = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/cif/basic", {
      flag: "BasicConversationReport",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const cifAdvanceConversationWithoutApproval = (payload) => {
  return axiosInstance
    .post(REPORT_URL + "/cif/basic", {
      flag: "advancedConversationReport",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const getSurveyGraphDetailsAllPeriodService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/fetch-graph-all-periods", {
      flag: "fetchGraphAllPeriodsByMember",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const getExpenseProjectsService = (workspaceID, onlyAccess) => {
  return axiosInstance
    .post(REMINDER_URL + "/reminder/projects", {
      flag: "getProjects",
      parameters: {
        workspaceId: workspaceID,
        search: "",
        onlyAccess: onlyAccess,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const periodicAssessmentConfigService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/schedule/update-schedule", {
      flag: "updateSurveySchedule",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

// Delete question cards
export const surveyQuestionDeleteService = (payload) => {
  const languageCode = localStorage.getItem("i18nextLng") || "en";
  return axiosInstance
    .put(CULTURALFIT + "/survey/delete/question", {
      flag: "deleteQuestionById",
      parameters: payload,
      languageCode,
    })
    .then((res) => {
      return res.data;
    });
};
// Delete question's option
export const surveyQuestionOptionDeleteService = (payload) => {
  const languageCode = localStorage.getItem("i18nextLng") || "en";
  return axiosInstance
    .put(CULTURALFIT + "/survey/delete/question-option", {
      flag: "deleteQuestionOptionById",
      parameters: payload,
      languageCode,
    })
    .then((res) => {
      return res.data;
    });
};

export const assessmentApprovalService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/fetch/approval", {
      flag: "fetchApprovalAssessment",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const assigneeDeliveryAnswerService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/answer/assignee-preview", {
      flag: "fetchAssigneeDeliveryAnswer",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

// Surevey approval
export const surveyAssigneeApprovalService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/approval/assignee-delivery", {
      flag: "approveOrRejectAssigneeDelivery",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const surveyUpdateAnswerService = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/survey/update/answer", {
      flag: "updateAssigneeDeliveryAnswer",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const surveyVerifyAnswered = (payload) => {
  return axiosInstance
    .post(CULTURALFIT + "/validate/submit", {
      flag: "validateSubmitSurvey",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const createHelpDeskTicket = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(`${HELPDESK_URL}/create`, {
        flag: "createTicket",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const updateHelpDeskTicket = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(`${HELPDESK_URL}/update`, {
        flag: "updateTicket",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const deleteHelpDeskTicket = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.delete(
        `${HELPDESK_URL}/delete?flag=deleteTicket&id=${data}`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getHelpDeskTickects = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(`${HELPDESK_URL}/search`, {
        flag: "searchTicket",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getHelpDeskMyTickects = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(`${HELPDESK_URL}/search`, {
        flag: "searchMyTicket",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getHelpDeskCategoryDropDown = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(
        `${HELPDESK_URL}/dropdowns?flag=getTicketCategory&idWorkspace=${data}`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getHelpDeskTicketPriorityDropDown = (onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(
        `${HELPDESK_URL}/dropdowns?flag=getTicketPriority`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getHelpDeskTicketStatusDropDown = (onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(
        `${HELPDESK_URL}/dropdowns?flag=getTicketStatus`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getHelpDeskTicketCommentsService = (idTicket) => {
  return axiosInstance
    .get(`${HELPDESK_URL}/comment?flag=getTicketComment&idTicket=${idTicket}`)
    .then((response) => {
      return response.data;
    });
};

export const createHelpDeskTicketComments = (payload) => {
  return axiosInstance
    .post(HELPDESK_URL + "/comment", {
      flag: "createComment",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const updateHelpDeskTicketComments = (payload) => {
  return axiosInstance
    .put(`${HELPDESK_URL}/comment?flag=updateTicketComment`, {
      flag: "updateTicketComment",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteHelpDeskTicketCommentService = (id) => {
  return axiosInstance
    .patch(`${HELPDESK_URL}/comment?flag=deleteTicketComment&id=${id}`)
    .then((response) => {
      return response.data;
    });
};

export const getHelpDeskCategoryList = (payload) => {
  return axiosInstance
    .post(`${HELPDESK_URL}/category/fetch`, {
      flag: "searchTicketCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const createHelpDeskSubCategory = (payload) => {
  return axiosInstance
    .post(`${HELPDESK_URL}/sub-category`, {
      flag: "createTicketSubCategory",
      parameters: payload,
    })
    .then((res) => res.data);
};

export const updateHelpDeskSubCategory = (payload) => {
  return axiosInstance
    .put(`${HELPDESK_URL}/sub-category`, {
      flag: "editTicketSubCategory",
      parameters: payload,
    })
    .then((res) => res.data);
};

export const deleteHelpDeskSubCategory = (payload) => {
  return axiosInstance
    .patch(
      `${HELPDESK_URL}/sub-category?flag=deleteTicketSubCategory&id=${payload.id}&idWorkspace=${payload.idWorkspace}&status=${payload.status}`,
    )
    .then((res) => res.data);
};

export const createHelpDeskCategory = (payload) => {
  return axiosInstance
    .post(`${HELPDESK_URL}/category`, {
      flag: "createTicketCategory",
      parameters: payload,
    })
    .then((res) => res.data);
};

export const updateHelpDeskCategory = (payload) => {
  return axiosInstance
    .put(`${HELPDESK_URL}/category`, {
      flag: "editTicketCategory",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const deleteHelpDeskCategory = (payload) => {
  return axiosInstance
    .patch(
      `${HELPDESK_URL}/category?flag=deleteTicketCategory&id=${payload.id}&idWorkspace=${payload.idWorkspace}&status=${payload.status}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getMyRequestedHelpDeskTickectService = (data) => {
  return axiosInstance
    .post(`${HELPDESK_URL}/search`, {
      flag: "seachMyRequestTicket",
      parameters: data,
    })
    .then((response) => response.data);
};
export const getChatRelatedService = (payload) => {
  return axiosInstance
    .post(`${OKR_URL}/objective/chat/selection`, {
      flag: "getConversationFilters",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getCustomChatRelatedService = (payload) => {
  // Backend expects: { id_workspace: UUID, id_session: UUID[], prompt: string }
  return axiosInstance
    .post(`${STRATEGY_BUILDER}/api/strategy`, payload, {
      headers: {
        "x-api-key": STRATEGY_API_KEY,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const publishStrategyService = (payload) => {
  // Backend expects: { id_workspace: UUID, id_session: UUID[], content: string }
  return axiosInstance
    .post(`${STRATEGY_BUILDER}/api/publish`, payload, {
      headers: {
        "x-api-key": STRATEGY_API_KEY,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const editStrategyService = (id_workspace, id_session) => {
  // Backend expects query parameters: id_workspace (UUID) and id_session (UUID)
  return axiosInstance
    .get(`${STRATEGY_BUILDER}/api/editstrategy`, {
      params: {
        id_workspace: id_workspace,
        id_session: id_session,
      },
      headers: {
        "x-api-key": STRATEGY_API_KEY,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const createKeyResultBulkService = (payload) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session/result/multi-create", {
      flag: "createMultiSessionKeyResult",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getOrgSubscription = (id) => {
  return axiosInstance
    .get(`${STRIPE_URL}/super-admin/retrieve-workspace-plan?workspaceId=${id}`)
    .then((response) => {
      return response.data;
    });
};

export const updateOrgSubscriptionService = (payload) => {
  return axiosInstance
    .post(STRIPE_URL + "/super-admin/update-workspace-plan", {
      payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getokrCRMWorkspaceMonday = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/monday/get`,
        {
          flag: "GET_ALL_WORKSPACES",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getOkrCRMBoardsMonday = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/monday/get`,
        {
          flag: "GET_ALL_BOARDS",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getOkrCRMFiltersList = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/monday/get`,
        {
          flag: "GET_ALL_COLUMN_VALUES",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const submitCRMFilters = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/keyresult/sync`,
        {
          flag: "SYNC_MONDAY_FILTER_DATA_KR",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const submitSyncConnectorsFilters = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/connector/resync`,
        {
          flag: "RESYNC_CONNECTOR_KR",
          parameters: data,
        },
      );

      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const mondayCRMUserList = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/monday/get`,
        {
          flag: "GET_MONDAY_USERS_LIST",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

//TODOS
export const assignTodosService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        TODOS_URL + "/todo-tags/assign",
        {
          flag: "assignTagsToTodo",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const createTodosService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(TODOS_URL + "/todos/create", {
        flag: "createTodos",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const bulkEditTodosService = (payload) => {
  return axiosInstance
    .put(`${TODOS_URL}/todos/bulk/edit`, {
      flag: "bulkEditTodos",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const updateTodosService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.put(`${TODOS_URL}/todos/edit`, {
        flag: "editTodos",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const updateImportantTodosService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.patch(
        `${TODOS_URL}/todos/importance/update`,
        {
          flag: "updateImportance",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const updateTodosProgressService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.patch(
        `${TODOS_URL}/todos/progress/status/update`,
        {
          flag: "progressStatusUpdate",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const deleteTodosService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.delete(`${TODOS_URL}/todos/delete`, {
        data: {
          flag: "deleteTodos",
          parameters: data,
        },
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getTodosService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(`${TODOS_URL}/todos/list/v2`, {
        // flag: "getAllTodosV2",
        flag: "getAllTodosListV2",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getObjectiveDashboard = (
  idWorkspace,
  startDate,
  endDate,
  limit,
  pageNo,
  status,
  sortedBy,
  orderBy,
  objectiveFiltersDTO,
  privacy,
  departmentIds,
) => {
  return axiosInstance
    .post(OKR_URL + "/objective/session/dashboard", {
      flag: "getObjectiveDashboard",
      parameters: {
        idWorkspace: idWorkspace,
        startDate: startDate,
        endDate: endDate,
        limit: limit,
        pageNo: pageNo,
        status: status,
        sortedBy,
        orderBy,
        objectiveFiltersDTO,
        privacy,
        departmentIds,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const timeoffGetRequestDashboard = (payload) => {
  return axiosInstance
    .post(TIMEOFF_URL + "/TimeOffRequest/getrequestlist", {
      flag: "getApprovalRequestlist",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const expenseApprovalDashboard = (payload) => {
  return axiosInstance
    .post(MEMBER_URL + "/member/expense", {
      flag: "ExpenseApproval",
      parameters: payload,
    })
    .then((response) => {
      return response.data;
    });
};

export const getokrCRMHubSpot = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(
        `${OKR_URL}/hubspot/object/properties?flag=${data.flagname}&workspaceId=${data.workspaceID}&objectType=${data.objType}`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getokrHubSpotContact = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(`${OKR_URL}/hubspot/contacts`, {
        flag: "SYNC_MONDAY_FILTER_DATA_KR",
        parameters: data,
      });
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const submitHubspotFilter = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/hubspot/objective/keyresult/sync`,
        {
          flag: "SYNC_HUBSPOT_FILTER_DATA_KR",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const inviteMemberByLinkService = (workspaceId, invite_token) => {
  return axiosInstance
    .post(MEMBER_URL + `/member/invite`, {
      flag: "inviteMemberByLink",
      parameters: {
        workspaceId: workspaceId,
        inviteToken: invite_token,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getAllRolePermissionList = (workspaceId) => {
  return axiosInstance
    .post(ADMIN_URL + `/custom-role/module-permissions`, {
      flag: "getModulesPermissions",
      parameters: {
        workspaceId: workspaceId,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const getAllRoleCustomRole = (workspaceId) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/custom-role/getall?flag=getAllCustomRole&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};
// Connectors Aivio Owners
export const getOwnersofAivio = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/aivio/sync`,
        {
          flag: "GET_ALL_WORKSPACES",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

// Connectors Aivio workspace
export const getWorkSpaceListofAivio = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/aivio/sync`,
        {
          flag: "GET_ALL_WORKSPACES",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

// Connectors Aivio Board list
export const getBoardsofAivio = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/aivio/sync`,
        {
          flag: "GET_ALL_MODULES",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

// get Aivio Owners
export const getAivioOwnersForFilter = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/aivio/sync`,
        {
          flag: "GET_ALL_OWNERS",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

// Submit Aivio
export const saveAivioFilters = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/aivio/sync`,
        {
          flag: "SYNC_AIVIO_FILTER_DATA_KR",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

// Connectors Aivio Filter List
export const getFilterListofAivio = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/aivio/sync`,
        {
          flag: "GET_ALL_COLUMNS",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

// Connectos Aivio Value
export const getFilterValueofAivio = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${OKR_URL}/objective/aivio/sync`,
        {
          flag: "GET_COLUMN_VALUES",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const deleteAllCustomRole = (id, workspaceId) => {
  return axiosInstance
    .post(ADMIN_URL + `/custom-role/delete`, {
      flag: "deleteCustomRole",
      parameters: {
        id: id,
        workspaceId: workspaceId,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getAllRoleBasePermission = (workspaceId) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/custom-role/getall?flag=getAllCustomRoleWithModules&workspaceId=${workspaceId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const createCustomRole = (
  workspaceId,
  roleType,
  roleName,
  autoIncludePermissionDeps,
  modulePermissions,
) => {
  return axiosInstance
    .post(ADMIN_URL + `/custom-role/create`, {
      flag: "createCustomRole",
      parameters: {
        workspaceId: workspaceId,
        roleType: roleType,
        roleName: roleName,
        autoIncludePermissionDeps: autoIncludePermissionDeps,
        modulePermissions: modulePermissions,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getRoleTypePermissions = (workspaceId, roleType) => {
  return axiosInstance
    .post(ADMIN_URL + `/custom-role/module-permissions`, {
      flag: "getRoleTypePermissions",
      parameters: {
        workspaceId: workspaceId,
        roleType: roleType,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const updateRoleTypePermissions = (payload) => {
  return axiosInstance
    .post(ADMIN_URL + `/custom-role/edit`, {
      flag: "editCustomRole",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};
export const generateWorkspaceApiKeyService = (generateWorkspacePayload) => {
  return axiosInstance
    .post(`${ADMIN_URL}/workspace/api-key/generate`, {
      flag: "GENERATE_WORKSPACE_API_KEY",
      parameters: generateWorkspacePayload,
    })
    .then((res) => res.data);
};
export const getWorkspaceApiKeyService = (workspaceId) => {
  return axiosInstance
    .get(
      `${ADMIN_URL}/workspace/api-key?flag=GET_WORKSPACE_API_KEY&idWorkspace=${workspaceId}`,
    )
    .then((res) => res.data);
};

export const saveWorkspaceThirdPartyConfigService = (payload) => {
  return axiosInstance
    .post(`${ADMIN_URL}/workspace/api-key/third-party-config`, {
      parameters: payload,
    })
    .then((res) => res.data);
};

export const deleteWorkspaceThirdPartyConfigService = (payload) => {
  return axiosInstance
    .delete(`${ADMIN_URL}/workspace/api-key/third-party-config`, {
      data: { parameters: payload },
    })
    .then((res) => res.data);
};

export const getPermissionsListDashboardService = (workspaceId) => {
  return axiosInstance
    .get(
      MEMBER_URL +
      `/member/workspace/dashboard?flag=GET_DASHBOARD_LIST&workspaceId=${workspaceId}`,
    )
    .then((res) => {
      return res.data;
    });
};

export const multiExpenseCreate = (payload) => {
  return axiosInstance
    .post(EXPENSE_URL + `/v2/expense/create`, {
      flag: "createExpense",
      parameters: payload,
    })
    .then((res) => {
      return res.data;
    });
};

export const createTodoTagsService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.post(
        `${TODOS_URL}/todo-tags/create`,
        {
          flag: "createTodoTag",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const getTodoTagsService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.get(
        `${TODOS_URL}/todo-tags/workspace?flag=getTagsByWorkspace&idWorkspace=${data.idWorkspace}`,
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const deleteTodoTagsService = (payloadData, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.delete(
        `${TODOS_URL}/todo-tags/delete`,
        {
          data: {
            flag: "deleteTodoTag",
            parameters: payloadData,
          },
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

export const updateTodoTagsService = (data, onSuccess, onError) => {
  return async () => {
    try {
      const response = await axiosInstance.put(
        `${TODOS_URL}/todo-tags/update`,
        {
          flag: "updateTodoTag",
          parameters: data,
        },
      );
      const result = response.data;
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };
};

// ── RMG Services ──────────────────────────────────────────────────────

export const rmgWeeklySummaryService = (workspaceId, dateFrom, dateTo) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/rmg/summary?workspaceId=${workspaceId}&startDate=${dateFrom}&endDate=${dateTo}`,
    )
    .then((response) => response.data);
};

export const rmgBillableTabService = (workspaceId, dateFrom, dateTo) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/rmg/billable?workspaceId=${workspaceId}&startDate=${dateFrom}&endDate=${dateTo}`,
    )
    .then((response) => response.data);
};

export const rmgLeaveAnalyticsService = (workspaceId, dateFrom, dateTo) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/rmg/leave-analytics?workspaceId=${workspaceId}&startDate=${dateFrom}&endDate=${dateTo}`,
    )
    .then((response) => response.data);
};

export const rmgSrJrService = (workspaceId) => {
  return axiosInstance
    .get(`${MEMBER_URL}/member/rmg/sr-jr-ratio?workspaceId=${workspaceId}`)
    .then((response) => response.data);
};

export const rmgResAvailService = (workspaceId, dateFrom, dateTo) => {
  return axiosInstance
    .get(
      `${MEMBER_URL}/member/rmg/resource-availability?workspaceId=${workspaceId}&startDate=${dateFrom}&endDate=${dateTo}`,
    )
    .then((response) => response.data);
};

// AI Chat services
export const aiChatCompletionService = (payload, signal) => {
  return axiosInstance.post(AI_SOW_CHAT_URL, payload, { useBearerToken: true, signal }).then((response) => response.data);
};

export const aiResponsesService = (payload) => {
  return axiosInstance.post(`${AI_CHAT_URL}/api/ai/responses`, payload, { useBearerToken: true }).then((response) => response.data);
};

export const aiTranscriptionService = (formData) => {
  return axiosInstance.post(`${AI_CHAT_URL}/api/ai/transcribe`, formData, {
    useBearerToken: true,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((response) => response.data);
};

export const getProjectFinancialSummaryService = (projectId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/reports/project-financial-summary?idProject=${projectId}&flag=GET_PROJECT_FINANCIAL_SUMMARY`
    )
    .then((response) => response.data);
};

export const exportProjectFinancialSummaryService = (projectId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/reports/project-financial-summary/export?idProject=${projectId}&flag=EXPORT_PROJECT_FINANCIAL_SUMMARY`
    )
    .then((response) => response.data);
};

export const getTMBudgetOverviewService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/tm/budget-overview?flag=GET_TM_BUDGET_OVERVIEW&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getTMSummaryKPIsService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/tm/summary-kpis?flag=GET_TM_SUMMARY_KPIS&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getTMEfficiencyService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/tm/efficiency?flag=GET_TM_EFFICIENCY&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const getTMMonthlyPlanService = (projectId, workspaceId) => {
  return axiosInstance
    .get(
      `${PROJECT_URL}/admin/project/tm/monthly-plan?flag=GET_TM_MONTHLY_PLAN&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const updateTMProjectPhaseService = (data) => {
  return axiosInstance
    .patch(
      `${PROJECT_URL}/admin/project/tm/members?flag=UPDATE_TM_PROJECT_PHASE`,
      data
    )
    .then((response) => response.data);
};

export const markPhaseAsPaidService = (data) => {
  return axiosInstance
    .post(
      `${INVOICE_URL}/invoice/MarkPhaseAsPaid`,
      data
    )
    .then((response) => response.data);
};

export const getInvoiceBoardService = (workspaceId) => {
  return axiosInstance
    .get(`${INVOICE_URL}/invoice/board?workSpaceId=${workspaceId}`)
    .then((response) => response.data);
};

export const searchInvoiceBoardService = (data) => {
  return axiosInstance
    .post(`${INVOICE_URL}/invoice/board/search`, data)
    .then((response) => response.data);
};

export const updateInvoiceBoardOrderService = (data) => {
  return axiosInstance
    .post(`${INVOICE_URL}/invoice/board/order`, data)
    .then((response) => response.data);
};

export const deleteSowAttachmentService = (attachmentId, projectId, workspaceId) => {
  return axiosInstance
    .delete(
      `${PROJECT_URL}/admin/project/sow/attachment?attachmentId=${attachmentId}&projectId=${projectId}&workspaceId=${workspaceId}`
    )
    .then((response) => response.data);
};

export const listProjectApprovalService = (payload) => {
  return axiosInstance
    .post(PROJECT_URL + "/admin/project/details-approval/search?flag=listProjectDetailsApproval", {
      parameters: payload,
    })
    .then((response) => response.data);
};


export const updateProjectApprovalService = (payload) => {
  return axiosInstance
    .patch(PROJECT_URL + "/admin/project/details-approval?flag=approveRejectProjectDetailsApproval", {
      parameters: payload,
    })
    .then((response) => response.data);
};

export const getIntegrationApiLogDetailService = (workspaceId, id) =>
  axiosInstance
    .post(`${MEMBER_URL}/member/integration/logs`, {
      flag: "GET_INTEGRATION_API_LOGS",
      parameters: { workspaceId, id },
    })
    .then((response) => response.data);

export const getIntegrationApiLogsService = (
  workspaceId,
  page = 1,
  limit = 50,
  dateFrom,
  dateTo
) => {
  const parameters = {
    workspaceId,
    page,
    limit,
  };
  if (dateFrom) parameters.dateFrom = dateFrom;
  if (dateTo) parameters.dateTo = dateTo;

  return axiosInstance
    .post(`${MEMBER_URL}/member/integration/logs`, {
      parameters,
    })
    .then((response) => response.data);
};
